import { Component, OnInit, Input, TemplateRef, OnChanges, SimpleChanges, Output, EventEmitter, ChangeDetectorRef, ViewChild, ViewContainerRef, ViewChildren, ElementRef, QueryList, HostListener, AfterViewChecked } from '@angular/core';
import { ItineraryService } from '../itinerary.service';
import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { flightIn, flightOut } from './flight.modal';
import { Observable } from 'rxjs/Observable';
import { UbicacionesService } from '../../home/search-box/service/ubicaciones.service';
import { MatDialog } from '@angular/material/dialog';
import { MaterialModalConfirmComponent } from '../material-modal-confirm/material-modal-confirm.component';
import { DomSanitizer} from "@angular/platform-browser";
import { UserService } from 'app/pages/com.usblick.common/auth/user.service';
import { HttpErrorResponse } from '@angular/common/http';
import * as moment from 'moment';
import { DatePipe } from '@angular/common';
import CssFilterConverter from 'css-filter-converter';
import { pipe, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, takeUntil } from 'rxjs/operators';
import { FormFlightInternalComponent } from './form-flight-internal/form-flight-internal.component';
import { ConfirmationModalComponent } from '../modals/confirmation-modal/confirmation-modal.component';
import { NotificationService } from '../notifications/notification.service';
moment.locale('es');
@Component({
  selector: 'usb-flight-modal',
  templateUrl: './flight-modal.component.html',
  styleUrls: ['./flight-modal.component.scss'],
  providers: [UbicacionesService, DatePipe]
})
export class FlightModalComponent implements OnInit, OnChanges, AfterViewChecked {

  @Input() invoke: number; // If its 0, comes from sidebar footer, 1 from head-band
  @Input() _actualItinerary: any;
  @Input() payloadSearch: any
  @Input() modeView: any;
  @Input() getClientsSettingAppBooking: any;
  @Input() openModalFly: boolean = false;
  @Input() formTransports: any;
  @Input() infoFly: any;
  @Input() component: string = '';
  @Input() actionComponent: string = '';
  @Output() updateFly = new EventEmitter<boolean>(false);
  @Output() modalClosed = new EventEmitter<void>();

  @ViewChild("template") template: any;
  @ViewChild(FormFlightInternalComponent) flightInternalComponent!: FormFlightInternalComponent;
  @ViewChildren('icons', { read: ElementRef }) icons : QueryList<ElementRef>;
  checked: boolean = false;

  flightIn: flightIn;
  flightOut: flightOut;
  dpConfig: Partial<BsDatepickerConfig> = new BsDatepickerConfig();
  modalRef: BsModalRef;
  minDate: Date;
  _formFlights: FormGroup;
  config = {
    animated: true,
    keyboard: true,
    backdrop: true,
    ignoreBackdropClick: true
  };
  ismeridian = true;
  selectedAirportIn: string = '';
  selectedAirportInId: any;
  selectedAirportInCountryCode: any;
  selectedAirportInCityName: string = '';
    selectedAirlineIn: string = '';
  selectedAirportOut: string = '';
  selectedAirportOutCityName: string = '';
  selectedAirlineOut: any;
  onlyIn: boolean = false;
  onlyOut: boolean = false;

  /** True when this modal is rendering the flight form for a transfers category 8
 *  context. Today this is informational only — full form is shown for all 3
 *  cases (pickup-airport, dropoff-airport, both). Kept as a flag for future
 *  behavior that may need to know we're in transfers. */
  isTransfersContext: boolean = false;

  /** True after the user clicked "Agregar vuelo de salida" so the button hides.
   *  Resets to false every time `_initFlightsForm` runs. */
  legUnlocked: boolean = false;

  /** Guard: set to true after patchForm() successfully completes so that
   *  ngOnChanges skips _initFlightsForm() and does not wipe the prefill. */
  private _prefillApplied: boolean = false;

  flightId: any;

  // Modal ref for removal confirmation
  removeConfirmModalRef: BsModalRef;

  // valueAirlineIn: any;
  valueAirlineCodeIata: any;
  minDateDeparture: Date;
  maxDateArrival: Date;
  minDateDeparturateOut: Date;
  minDateArrivalOut: Date;
  maxDateDepartureDateIn: Date = null;
  bsConfig: object;
  message = [];

  isLoadingResult: boolean;
  errorMsg: string;
  keyword = 'nameAirline';

  _flightNumberIn: any;
  __airlineIn: any;
  minArrivalInHour: string | null = null;
  isHoveredCancelDate: boolean;
  isHoveredSwapBtn: boolean = false;
  /** Tracks click-driven rotation of the swap button (180° per click). */
  isRotatedSwap: boolean = false;
  flyShowComponent: any;
  flyArr: any[] = [];
  tooltipFlight: boolean = false;
  colorFlight: string;
  countriesList: any[] = [];

  selectedCityIataIn: any;
  valueCityCodeIataIn: any;
  selectedCityIataInName: any;

  selectedIataCityArrivalOutName: any;
  selectedIataCityArrivalOut: any;
  valueCityCodeIataOut: any;

  isFormValidFlyInternal = true;
  flightsInternal: any[] = [];
  isPatching: boolean = false;
  newFlightsArr: any[] = [];
  isChildAccordionOpen = false;
  selectedAirlineInName: string = '';
  selectedAirlineOutName: string = '';
  private _lastFlights: any[] = [];
  private _cachedResult: any[] = [];

  // Wheel time picker support
  activeTimePicker: 'arrivalHourIn' | 'departureHourOut' | null = null;
  currentTime: string = new Date().toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  });

  // Tracks previous valid time values for blur revert
  private _previousTimeValues: Record<'arrivalHourIn' | 'departureHourOut', string | null> = {
    arrivalHourIn: null,
    departureHourOut: null,
  };

  // [SDD-DIAG] Throttle for the _syncHourControls diagnostic log.
  private _lastDiagAt: number = 0;

  // Throttle for the DOM-attribute sync that locks the autocomplete /
  // bsDatepicker inputs. ngAfterViewChecked fires very often; without this
  // we'd re-iterate the DOM on every keystroke from anywhere in the modal.
  private _lastDomSyncAt: number = 0;

  private destroy$ = new Subject<void>();

  // Tears down prior date subscriptions on re-entrancy
  private _formRebuild$ = new Subject<void>();

  constructor(
    private modalService: BsModalService,
    private ubicacionesService: UbicacionesService,
    private _formBuilder: FormBuilder,
    private _itineraryService: ItineraryService,
    public dialog: MatDialog,
    private _sanitizer: DomSanitizer,
     public userService: UserService,
     private notificationService: NotificationService,
     private cdr: ChangeDetectorRef
    ) {
        this.minDate = new Date();
        this.minDateDeparturateOut = new Date();
        this.minDateArrivalOut = new Date();
        this.minDate.setDate(this.minDate.getDate());
        this.dpConfig.dateInputFormat = "DD/MM/YYYY";
      }


  ngOnInit(): void
              {
                if(this._actualItinerary) {
                  this._actualItinerary.flights = this._actualItinerary?.flights;
                }
                 this.colorFlight = this.getClientsSettingAppBooking?.clients_setting_global?.color_main_1;
                this._initData();
              }

  ngOnChanges(changes: SimpleChanges): void
              {

                if (changes['payloadSearch']?.['currentValue']) {
                  const newPayload = changes['payloadSearch']['currentValue'];
                  const newIsTransfers = !!(
                    newPayload &&
                    newPayload[0]?.categoriesId?.[0] === 8
                  );
                  if (newIsTransfers !== this.isTransfersContext) {
                    this.isTransfersContext = newIsTransfers;
                    if (!this.modalRef) {
                      this._initFlightsForm();
                    }
                  }
                }

                if(changes['_actualItinerary']?.['currentValue']) {
                  this._actualItinerary = changes['_actualItinerary']['currentValue'];
                  if(this._actualItinerary && this._actualItinerary.flights) {
                    this._actualItinerary.flights = this._reorderFlightsGeneralFirst(this._actualItinerary.flights);
                    if(this._actualItinerary.flights.length > 0) {
                        this.invoke = 1;
                    }
                    this.getFlyItineraries();
                    if (!this._prefillApplied) {
                      this._initFlightsForm();
                    }
                  }
                }
                if(this.openModalFly) {
                  this._initData();
                  setTimeout(() => {
                    this.openModalWithClass(this.template);
                  }, 100);
                }
              }

  _initData() {
    this.getFlyItineraries();
    this._initFlightsForm();
    this.invoke = 0;

    if(this._actualItinerary?.flights && this._actualItinerary?.flights.length > 0) {
      this.invoke = 1;
    }
  }

  closeModal(): void {
    this.cleanUnsavedFlights();
    this.resetForm();

     if (this.flightInternalComponent) {
      this.flightInternalComponent.resetForms(); // Asegúrate de implementar este método en el hijo
    }

    this.modalRef.hide();
    this.modalClosed.emit();

  }

  /**
 * Elimina los vuelos internos que no tienen ID (no guardados en BD)
 */
cleanUnsavedFlights(): void {
  if (this.flightsInternal && this.flightsInternal.length > 0) {
    // Filtrar solo los vuelos que tienen ID (ya guardados)
    this.flightsInternal = this.flightsInternal.filter(flight => flight.id !== null && flight.id !== undefined);
  }
}

/**
 * Elimina un vuelo del itinerario actual previa confirmación del usuario
 *
 * Este método abre un modal de confirmación y, si el usuario acepta, realiza una petición DELETE
 * al endpoint correspondiente para eliminar el vuelo del itinerario actual.
 *
 * @param {number} [index] - Índice opcional del vuelo a eliminar (no utilizado en la implementación actual)
 *
 * @emits updateFly - Evento emitido cuando la eliminación es exitosa
 *
 * @uses MaterialModalConfirmComponent - Componente modal para confirmación de acciones
 * @uses _itineraryService._restService.doDelete - Servicio para realizar peticiones DELETE
 *
 * @example
 * // Ejemplo de uso:
 * this._removeFlight();
 *
 * @response {any} - Respuesta exitosa del servidor
 * @error {HttpErrorResponse} - Error en la petición HTTP
 * @throws {Error} - Error al procesar la eliminación
 */
  _removeFlight(id?: number, first?: boolean) {


    const initialState: ModalOptions = {
      initialState: {
        title: 'Eliminar',
        message: '¿Estas seguro de eliminar este Vuelo?',
        icon: 'assets/icons/itinerary-detail/04-01.svg'
      }
    }

    const modalOptions = Object.assign({}, initialState, this.config, { class: 'gray custom-container-transport' } );
    this.removeConfirmModalRef = this.modalService.show(ConfirmationModalComponent,  modalOptions);


    this.removeConfirmModalRef.content.confirmResult.subscribe((result: boolean) => {
      if(result){
      // const id = this._actualItinerary['id'];
      this._itineraryService._restService.doDelete("app", "fly_itineraries/" + id).subscribe(
        (response: any) => {
          this.notificationService.success(`Vuelo eliminado con exito para el file ${id}`);

          if (Array.isArray(this._actualItinerary?.flights)) {
            this._actualItinerary.flights = this._actualItinerary.flights.filter(
              (flight: any) => String(flight?.id) !== String(id)
            );
          }

          this.flightsInternal = this.flightsInternal.filter(
            (flight: any) => String(flight?.id) !== String(id)
          );
          this._lastFlights = [];
          this._cachedResult = [];
          this.invoke = this._actualItinerary?.flights?.length > 0 ? 1 : 0;

          if(first === true) {
            this.closeModal();
            this.flightIn = null;
            this.flightOut = null;
          }

          this.getFlyItineraries(() => {
            this.cdr.detectChanges();
            this.updateFly.emit(true);
          });
        },
        (error) => {
          this.notificationService.error(`Hubo un error al eliminar el vuelo para el file ${id}, ${error.error}`)
        }
      );
    } else {
      this.removeConfirmModalRef.hide();
    }
    });
  }

  onFormValidityChange(isValid: boolean): void {
      this.isFormValidFlyInternal = isValid;
  }

  /**
 * Aplica cambios de vuelos al itinerario actual
 *
 * Este método valida el formulario, construye el payload y realiza peticiones POST o PUT
 * según corresponda para crear o actualizar vuelos en el itinerario actual.
 *
 * @returns {void}
 *
 * @emits updateFly - Evento emitido cuando la operación es exitosa
 *
 * @requires _formFlights válido - El formulario debe pasar las validaciones
 * @requires checkFlight() verdadero - Verificación adicional de vuelos
 *
 * @uses payloadMap() - Método para construir el payload de la petición
 * @uses MaterialModalConfirmComponent - Componente modal para confirmación de acciones
 * @uses _itineraryService._restService - Servicio para peticiones HTTP
 *
 * @example
 * // Ejemplo de uso:
 * this._flightsApply();
 *
 * @response {any} - Respuesta exitosa del servidor
 * @error {HttpErrorResponse} - Error en la petición HTTP
 * @throws {Error} - Error al procesar la operación
 */
  _flightsApply() {

    // Marcar todos los controles como touched para que se muestren los mensajes de error
    this._formFlights.markAllAsTouched();

    // Validate per-leg. A leg is required if it is currently visible
    // (`onlyIn` / `onlyOut`), not if it has any value. Otherwise the user
    // could open the "Agregar vuelo de salida" block, leave it empty, and
    // submit — that would persist a broken flight on the backend.
    const airlineIn = this._formFlights.get('airlineIn')?.value;
    const airlineOut = this._formFlights.get('airlineOut')?.value;
    // A leg is required whenever it is visible in the form. If the user has
    // shown the departure leg ("Agregar vuelo de salida") its fields become
    // mandatory regardless of whether they are filled yet — leaving the form
    // empty must block submit so we don't persist a broken flight.
    const hasIn = this.onlyIn;
    const hasOut = this.onlyOut;

    if (!hasIn && !hasOut) {
      this.notificationService.info('Complete al menos un vuelo (llegada o salida)');
      return;
    }

    const missingFields: string[] = [];
    const inRequired = ['airlineIn', 'arrivalDateIn', 'arrivalHourIn', 'airportIn', 'flightNumberIn'];
    const outRequired = ['airlineOut', 'departureDateOut', 'departureHourOut', 'airportOut', 'flightNumberOut'];
    const fieldsToCheck = [...(hasIn ? inRequired : []), ...(hasOut ? outRequired : [])];
    fieldsToCheck.forEach(controlName => {
      const control = this._formFlights.get(controlName);
      if (!control) return;
      const value = control.value;
      const hasNoValue = value === null || value === ''
        || (Array.isArray(value) && value.length === 0);
      if (hasNoValue || (control.invalid && control.touched)) {
        missingFields.push(controlName);
      }
    });

    if (missingFields.length > 0) {
      this.notificationService.info('Faltan datos obligatorios por completar');
      return;
    }

    if(!this.isFormValidFlyInternal) {
      this.notificationService.info('Tiene formularios de vuelos internos sin completar. Por favor completelos para poder continuar');
      return;
    }

    if (hasIn) {
      const arrivalDate = this._formFlights.get('arrivalDateIn')?.value;
      const arrivalHour = this._formFlights.get('arrivalHourIn')?.value;
      if (!arrivalDate || !arrivalHour || !/^\d{1,2}:\d{2}$/.test(arrivalHour)) {
        this.notificationService.info('Complete la fecha y hora de llegada antes de continuar');
        return;
      }
    }

    if (hasOut) {
      const departureDate = this._formFlights.get('departureDateOut')?.value;
      const departureHour = this._formFlights.get('departureHourOut')?.value;
      if (!departureDate || !departureHour || !/^\d{1,2}:\d{2}$/.test(departureHour)) {
        this.notificationService.info('Complete la fecha y hora de salida antes de continuar');
        return;
      }
    }

      const isEdit = !!(this._actualItinerary && this._actualItinerary.flights.length > 0);
      let payloadFly = this.payloadMap(isEdit);




        if(isEdit) {
          payloadFly['id'] = this._actualItinerary.flights[0].id;
        }

        const initialState: ModalOptions = {
          initialState: {
              title: isEdit ? 'Editar vuelo' : 'Crear vuelo',
              subtitle: 'para este file',
              message: 'confirme si desea realizar <br /> esta operación',
              icon: '/assets/icons/search-result/airplane_3313713.svg'
            }
          }

        const modalOptions = Object.assign({}, initialState, this.config, { class: 'gray custom-container-transport' });
        const modalConfirm = this.modalService.show(ConfirmationModalComponent,  modalOptions);
        const instance = modalConfirm.content as unknown as MaterialModalConfirmComponent;

        if (payloadFly['id']) {
          instance.confirmResult.subscribe((result: boolean) =>{
            if(result) {
              this._itineraryService._restService.doPut('app', `fly_itineraries/${payloadFly['id']}`, payloadFly).subscribe({
                next: (res: any) => {
                                       this.refreshFlightAfterSave(payloadFly['id'], () => {
                                         this.finishFlightSave(`Vuelo actualizado con exito para el file ${this._actualItinerary['id']}`);
                                       });
                                    },
                error: (error: HttpErrorResponse) => {this.notificationService.error(`Hubo un error al actualizar el vuelo para el file ${this._actualItinerary['id']}, ${error.error}`)}
              });
            } else {
              return;
            }
          });

        } else {

          instance.confirmResult.subscribe((result: boolean) => {
            if(result) {
              this._itineraryService._restService.doPost('app', 'fly_itineraries', payloadFly).subscribe({
                next: (res: any) => {
                                      const newFlightId = res?.data?.id;
                                      if (newFlightId) {
                                        // Wait for the GET to finish before closing so the
                                        // parent's GET (triggered by `updateFly`) can't race
                                        // and overwrite our fresh data.
                                         this.refreshFlightAfterSave(newFlightId, () => {
                                           this.finishFlightSave(`Vuelo creado con exito para el file ${this._actualItinerary['id']}`);
                                         });
                                       } else {
                                         this.finishFlightSave(`Vuelo creado con exito para el file ${this._actualItinerary['id']}`);
                                       }
                                    },
                error: (error: HttpErrorResponse) => {this.notificationService.error(`Hubo un error al crear el vuelo para el file ${this._actualItinerary['id']}, ${error.error}`)}
              });
            } else {
              return;
            }
          })
        }




    }

    /**
 * Valida la coherencia temporal entre traslados y vuelos del itinerario
 *
 * Este método realiza validaciones complejas de fechas y horarios para asegurar que:
 * - Los traslados de ida y regreso sean cronológicamente consistentes
 * - Los traslados respeten los tiempos mínimos requeridos respecto a los vuelos
 * - Las fechas de recogida sean anteriores a las de llegada de vuelos
 *
 * @returns {boolean} - `true` si todas las validaciones pasan, `false` si hay inconsistencias
 *
 * @requires formTransports - Formulario de traslados debe estar disponible
 * @requires _actualItinerary.flights - Información de vuelos debe estar cargada
 *
 * @validation
 * - Fecha de recogida ida vs fecha de regreso
 * - Hora de recogida ida vs hora de regreso (mismo día)
 * - Fecha recogida ida vs fecha llegada vuelo
 * - Hora recogida ida vs hora llegada vuelo (+1h15min margen)
 * - Fecha recogida regreso vs fecha salida vuelo
 * - Hora recogida regreso vs hora salida vuelo (+3h30min margen)
 *
 * @uses moment.js - Para formateo y manipulación de fechas
 * @uses notification - Para mostrar mensajes informativos al usuario
 *
 * @example
 * // Ejemplo de uso:
 * const isValid = this.checkFlight();
 * if (!isValid) {
 *   // Mostrar error al usuario
 * }
 *
 * @message {string} - Mensajes descriptivos de error para cada validación fallida
 */
  checkFlight(): boolean {
      let result = true;
      const a = this.formTransports;

          // Declaración de variables para las fechas y horarios de los traslados
        let firstArrivalDate: string;
        let secondArrivalDate: string | null = null; // Inicializa en `null` si es un viaje de ida
        let firstTime: string;
        let secondTime: string;
        let arrivalHourIn: string;
        let arrivalDateIn: string;
        let departureDateOut: string;
        let departureHourOut: string;
        let st: number = 0; // Inicializa `st` en 0 para evitar errores si no se asigna
        let ft: number;
        let message: string = '';

        if(a) {
          // Obtiene la fecha y hora del primer traslado
          firstArrivalDate = moment(a['firstArrivalDate'].toString().split(',')[0]).format('YYYY-MM-DD');
          firstTime = moment(a['firstTime'].toString().split(',')[0]).format('HH:mm');

          // Convierte la hora a minutos totales en el día (Ej: 14:30 → 870 minutos)
          ft = parseInt(firstTime.split(':')[0], 10) * 60 + parseInt(firstTime.split(':')[1], 10);

          // Si el tipo de viaje no es "oneTrip" (solo ida), obtiene los datos del segundo traslado
          if (a['type'] !== 'oneTrip') {
              secondArrivalDate = moment(a['secondArrivalDate'].toString().split(',')[0]).format('YYYY-MM-DD');
              secondTime = moment(a['secondTime'].toString().split(',')[0]).format('HH:mm');
              st = parseInt(secondTime.split(':')[0], 10) * 60 + parseInt(secondTime.split(':')[1], 10);
          }

          // Validaciones de los traslados
          if (firstArrivalDate > (secondArrivalDate || firstArrivalDate)) {
              result = false;
              message = `Error, ingrese una fecha de recogida de ida anterior a la de regreso: ${firstArrivalDate}`;
          }

          if ((ft > st) && (firstArrivalDate === secondArrivalDate)) {
              result = false;
              message = `Error, ingrese una hora de recogida de ida anterior a la de regreso: ${secondTime}`;
          }
        }

        // Validaciones en relación con los vuelos
        if ((this._actualItinerary.flights && this._actualItinerary.flights.length > 0 && this._actualItinerary.flights[0].id)) {

            const fly =  this._actualItinerary.flights[0];
            // Obtiene los datos del vuelo
            arrivalDateIn = moment(fly.arrivalIn.toString().split(',')[0]).format('YYYY-MM-DD');
            arrivalHourIn = moment(fly.arrivalIn.toString().split(',')[0]).format('HH:mm');
            const at = parseInt(arrivalHourIn.split(':')[0], 10) * 60 + parseInt(arrivalHourIn.split(':')[1], 10);

            departureDateOut = moment(fly.departureOut.toString().split(',')[0]).format('YYYY-MM-DD');
            departureHourOut = moment(fly.departureOut.toString().split(',')[0]).format('HH:mm');
            const _at = parseInt(departureHourOut.split(':')[0], 10) * 60 + parseInt(departureHourOut.split(':')[1], 10);

            // Verifica si el primer traslado es antes de la llegada del vuelo
            if (firstArrivalDate > arrivalDateIn) {
                result = false;
                message = `Error, la fecha de recogida de ida debe ser anterior a la llegada del vuelo: ${arrivalDateIn}`;
            }

            // Ajuste de tiempo mínimo de espera (1 hora y 15 minutos) entre el traslado y el vuelo
            ft = ft + 75;
            if ((ft > at) && (firstArrivalDate === arrivalDateIn)) {
                result = false;
                message = `Error, la hora de recogida de ida debe ser al menos 1h 15min antes de la llegada del vuelo: ${arrivalHourIn}`;
            }

            // Verifica si el segundo traslado es después de la salida del vuelo
            if (secondArrivalDate && secondArrivalDate > departureDateOut) {
                result = false;
                message = `Error, la fecha de recogida de regreso debe ser anterior a la salida del vuelo: ${departureDateOut}`;
            }

            // Ajuste de tiempo mínimo de espera (3 horas y 30 minutos) entre el traslado y la salida del vuelo
            st = st + 210;
            if ((st > _at) && (secondArrivalDate === departureDateOut)) {
                result = false;
                message = `Error, la hora de recogida de regreso debe ser al menos 3h 30min antes de la salida del vuelo: ${departureHourOut}`;
            }
        }

        if(message !== '') {
          this.notificationService.info(message);
        }


      return result;
  }

  /**
 * Construye el payload para operaciones CRUD de vuelos
 *
 * Este método mapea los valores del formulario de vuelos a un objeto estructurado
 * apto para ser enviado al backend en operaciones POST/PUT.
 *
 * @returns {any} - Objeto payload estructurado para la API
 *
 * @requires _formFlights - Formulario de vuelos debe estar disponible y con controles definidos
 * @requires userService._agentID - ID del agente debe estar disponible
 * @requires selectedAirportInCountryCode - Código IATA del país del aeropuerto de entrada
 * @requires selectedAirportInId - ID del aeropuerto de entrada
 *
 * @structure
 * - Propiedades base: agent_id, iata_code, id_airport, itinerary
 * - Objeto `in`: Datos del vuelo de entrada (si existe)
 * - Objeto `out`: Datos del vuelo de salida (si existe)
 *
 * @uses formatDateOnly() - Método auxiliar para formatear fechas
 * @uses getVal() - Función helper para obtener valores del formulario
 *
 * @example
 * // Ejemplo de uso:
 * const payload = this.payloadMap();
 * this.service.saveFlight(payload).subscribe(...);
 *
 * @note Los valores nulos se manejan con operador de coalescencia nula (??)
 * @note Las fechas se combinan con sus respectivas horas
 */
   payloadMap(isEdit: boolean = false): any {

    const getVal = (control: string) => this._formFlights.get(control)?.value;

    const arrivalDateIn = this.formatDateOnly(getVal('arrivalDateIn'));
    const departureDateOut = this.formatDateOnly(getVal('departureDateOut'));

    let itineraryId: number = -1;

    if(this.flyShowComponent && this.flyShowComponent?.id) {
      itineraryId = this.flyShowComponent.id;
    }

    if(itineraryId === -1) {
       itineraryId = this._actualItinerary['id']
    }


        let payload: any = {
          agent_id: this.userService._agentID,
          iata_code: this.selectedAirportInCountryCode,
          id_airport: this.selectedAirportInId,
          itinerary: itineraryId,

        };

    const hasIn = !!getVal('airlineIn')?.name;
    const hasOut = !!getVal('airlineOut')?.name;

    if(hasIn) {
      payload.in = {
        airline: getVal('airlineIn')?.name ?? null,
        airlineIataCode: getVal('airlineIn')?.iata ?? null,
        airport: getVal('airportIn')?.name ?? null,
        airportIataCode: this.selectedAirportIn,
        airportInCityName: this.selectedAirportInCityName || null,
        // iataCityDeparture: getVal('cityDepartureIn'),
        flyNumber: getVal('flightNumberIn') ?? null,
        arrival: `${arrivalDateIn} ${getVal('arrivalHourIn')}`,
      }
    } else if(isEdit) {
      payload.in = [];
    }

    if(hasOut) {
      const existingFlight = this._actualItinerary?.flights && this._actualItinerary?.flights.length > 0 ? this._actualItinerary?.flights[0] : null;
      payload.out = {
          airline: getVal('airlineOut')?.name ?? null,
          airlineIataCode: getVal('airlineOut')?.iata ?? null,
          iataCityArrival: existingFlight?.iataCityArrivalOut ?? null,
          cityArrival: existingFlight?.cityArrivalOut ?? null,
          airport: getVal('airportOut')?.name ?? null,
          airportIataCode: this.selectedAirportOut,
          airportOutCityName: this.selectedAirportOutCityName || null,
          flyNumber: getVal('flightNumberOut') ?? null,
          departure: `${departureDateOut} ${getVal('departureHourOut')}`,
      }
    } else if(isEdit) {
      payload.out = [];
    }

    return payload;
  }

/**
 * Formatea un objeto Date a string en formato ISO (YYYY-MM-DD) sin información de tiempo
 *
 * Este método utility toma un objeto Date y extrae solo la parte de la fecha (año, mes, día),
 * ignorando cualquier información de hora, minutos, segundos y zona horaria.
 *
 * @param {Date} date - Objeto Date a formatear
 * @returns {string} - String con la fecha en formato ISO (YYYY-MM-DD) o undefined si la fecha es falsy
 *
 * @example
 * // Ejemplo de uso:
 * const date = new Date('2023-12-25T15:30:00');
 * const formatted = this.formatDateOnly(date); // Retorna "2023-12-25"
 *
 * @note Retorna undefined si el parámetro date es null, undefined o falsy
 * @note Usa el constructor de Date con componentes específicos para evitar problemas de zona horaria
 * @note El método toISOString() siempre retorna la fecha en UTC
 *
 * @implementation
 * 1. Crea un nuevo Date object usando solo año, mes y día
 * 2. Convierte a formato ISO string
 * 3. Extrae los primeros 10 caracteres (YYYY-MM-DD)
 */
  private formatDateOnly(date: Date): string {
    if(!date) {
      return;
    }
  const d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  return d.toISOString().slice(0, 10);
}

/**
 * Abre un modal con clase personalizada y configura el estado según la acción
 *
 * Este método abre un modal Bootstrap con clases CSS personalizadas y realiza
 * diferentes inicializaciones basadas en el componente y acción especificados.
 *
 * @param {TemplateRef<any>} template - Template reference del modal a abrir
 * @param {string} [action] - Acción a realizar: 'new' para nuevo vuelo, otros valores para edición
 * @param {any} [infoFly] - Información del vuelo existente para edición (opcional)
 *
 * @uses modalService.show() - Servicio de modales de Bootstrap
 * @uses _initData() - Inicializa datos para nuevo vuelo
 * @uses resetForm() - Reinicia formulario para nuevo vuelo
 * @uses patchForm() - Rellena formulario con datos existentes
 *
 * @example
 * // Abrir modal para nuevo vuelo:
 * this.openModalWithClass(template, 'new');
 *
 * // Abrir modal para editar vuelo existente:
 * this.openModalWithClass(template, 'edit', flightData);
 *
 * @configuration
 * - Clase CSS: 'gray modal-lg custom-container-transport'
 * - Configuración base: this.config
 *
 * @componentBehavior
 * - Si component === 'fly' AND action === 'new': Inicializa datos y resetea formulario
 * - Si component === 'fly' AND action !== 'new': Parchea formulario con infoFly
 * - Si component === 'results': Parchea formulario (sin info específica)
 */
  openModalWithClass(template: TemplateRef<any>, action?: string, infoFly?: any) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, this.config, { class: 'gray modal-lg custom-container-transport' })
    );

    if(this.component === 'fly' && action === 'new') {
      this._initData();
      this.resetForm();
    }

    if(this.component === 'fly' && action !== 'new') {
      this.flyShowComponent = infoFly;
      this._initData();
      setTimeout(() => {
        this.patchForm(infoFly);
      }, 0);
    }
    if(this.component === 'results') {
      this._initData();
      this._initFlightsForm();
      const flight =  this._actualItinerary?.flights && this._actualItinerary?.flights.length > 0 ? this._actualItinerary?.flights[0] : null;
      if (flight) {
        setTimeout(() => {
          this.patchForm(flight);
        }, 50);
      } else {
        // No flight yet — invoke patchForm() with no args so the transfers prefill runs.
        setTimeout(() => {
          this.patchForm();
        }, 50);
      }
    }
  }

  /**
   * Re-fetch a flight by id and update `_actualItinerary.flights` with the
   * fresh data. The backend PUT/POST endpoints return `data: null`, so we
   * can't rely on the response to refresh local state. Doing a fresh GET
   * here keeps the modal in sync with what the backend persisted.
   */
  /**
   * Re-fetch a flight by id and update `_actualItinerary.flights` with the
   * fresh data. The backend PUT/POST endpoints return `data: null`, so we
   * can't rely on the response to refresh local state. Doing a fresh GET
   * here keeps the modal in sync with what the backend persisted.
   */
  private finishFlightSave(message: string): void {
    this.notificationService.success(message);
    this.openModalFly = false;
    this.closeModal();
    this.updateFly.emit(true);
  }

  refreshFlightAfterSave(flightId: number, onComplete?: () => void): void {
    this._itineraryService._restService
      .doGet('app', `fly_itineraries/${flightId}`)
      .subscribe({
        next: (res: any) => {
          // The endpoint may return `data` as either an object (single flight)
          // or an array of one (older backend version). Normalize both cases.
          const flight: any = Array.isArray(res?.data) ? res.data[0] : res?.data;
          if (flight && this._actualItinerary?.flights) {
            // Filter out any stale entries for this id (they might have a
            // different type — number vs string — so `findIndex` would miss
            // them and we'd end up duplicating). Then insert the fresh data.
            const baseFlights = this._actualItinerary.flights.filter(
              (f: any) => f?.id !== flight.id && f?.id !== +flight.id
            );
            baseFlights.push(flight);
             this._actualItinerary.flights =
               this._reorderFlightsGeneralFirst(baseFlights);
             this._lastFlights = [];
             this._cachedResult = [];
             this.invoke = 1;
             this.getFlyItineraries(() => {
               this.cdr.detectChanges();
               if (onComplete) onComplete();
             });
             return;
           }
           if (onComplete) onComplete();
        },
        error: (_err: any) => {
          if (onComplete) onComplete();
        },
      });
  }

  /**
 * Inicializa los objetos de vuelo de entrada y salida con valores por defecto
 *
 * Este método prepara las estructuras de datos para almacenar información de vuelos,
 * estableciendo todas las propiedades a null como estado inicial.
 *
 * @returns {void}
 *
 * @structure flightIn - Objeto para vuelo de entrada (llegada)
 * @property {Date|null} arrivalDateIn - Fecha de llegada del vuelo de entrada
 * @property {any|null} airportIn - Información del aeropuerto de entrada
 * @property {string|null} airportIataCodeIn - Código IATA del aeropuerto de entrada
 * @property {any|null} airlineIn - Información de la aerolínea de entrada
 * @property {string|null} _flightNumberIn - Número de vuelo de entrada (interno)
 * @property {string|null} flightNumberIn - Número de vuelo de entrada
 * @property {string|null} airlineIataCodeOut - Código IATA de aerolínea de salida (¿typo?)
 *
 * @structure flightOut - Objeto para vuelo de salida (regreso)
 * @property {Date|null} departureDateOut - Fecha de salida del vuelo de salida
 * @property {string|null} airportIataCodeOut - Código IATA del aeropuerto de salida
 * @property {any|null} airportOut - Información del aeropuerto de salida
 * @property {any|null} airlineOut - Información de la aerolínea de salida
 * @property {string|null} _flightNumberOut - Número de vuelo de salida (interno)
 * @property {string|null} flightNumberOut - Número de vuelo de salida
 * @property {string|null} airlineIataCodeOut - Código IATA de aerolínea de salida
 *
 * @note La propiedad `arrivalDateOut` en flightOut está comentada, posiblemente no utilizada
 * @note airlineIataCodeOut aparece en ambos objetos, posible duplicación en flightIn
 *
 * @example
 * // Ejemplo de uso:
 * this.iniFlightObject();
 * // Ahora flightIn y flightOut están inicializados con null values
 */
  iniFlightObject() {
    this.flightIn = {

      arrivalDateIn: null,
      airportIn: null,
      airportIataCodeIn: null,
      airlineIn: null,
      _flightNumberIn: null,
      flightNumberIn: null,
      airlineIataCodeOut : null,
    };
    this.flightOut = {
      departureDateOut: null,
      // arrivalDateOut: null,
      airportIataCodeOut: null,
      airportOut: null,
      airlineOut: null,
      _flightNumberOut: null,
      flightNumberOut: null,
      airlineIataCodeOut : null
    };

  }

  /***********************************************Auto Complete********************************************/
  /**
 * Formatea la visualización de aeropuertos en listas desplegables
 *
 * Este método genera HTML seguro para mostrar información de aeropuertos en formatos
 * personalizados dentro de componentes de autocompletado o selección.
 *
 * @param {any} data - Objeto con los datos del aeropuerto
 * @param {string} data.name - Nombre del aeropuerto
 * @param {string} data.iata - Código IATA del aeropuerto
 *
 * @returns {SafeHtml} - HTML sanitizado y seguro para renderizar
 *
 * @uses DomSanitizer.bypassSecurityTrustHtml - Para permitir HTML seguro
 * @uses capitalize() - Método para capitalizar el nombre del aeropuerto
 *
 * @format
 * - Ícono de avión (fa-plane)
 * - Nombre del aeropuerto capitalizado
 * - Código IATA entre paréntesis en negrita
 *
 * @example
 * // Retorna: HTML con "José Martí (HAV)"
 * this._myListFormatterAirport({name: 'josé martí', iata: 'HAV'});
 */
  _myListFormatterAirport = (data: any) => {
    // fa fa-building-o
    const html = `<span class='fa fa-plane'style='color:#a9a4a4'>
                      </span>
                      <span style='font-size:15px;cursor:pointer;line-height:2.1;'>
                        ${ this.capitalize(data['name'])}
                      </span>
                      <span style=' font-weight: 500;font-size:14px;color:black'>
                       (${data['iata']})
                      </span>`;
     return this._sanitizer.bypassSecurityTrustHtml(html);
  }

/**
 * Formatea la visualización de aerolíneas en listas desplegables
 *
 * Este método genera HTML seguro para mostrar información de aerolíneas en formatos
 * personalizados dentro de componentes de autocompletado o selección.
 *
 * @param {any} data - Objeto con los datos de la aerolínea
 * @param {string} data.name - Nombre de la aerolínea
 * @param {string} data.iata - Código IATA de la aerolínea
 *
 * @returns {SafeHtml} - HTML sanitizado y seguro para renderizar
 *
 * @uses DomSanitizer.bypassSecurityTrustHtml - Para permitir HTML seguro
 *
 * @format
 * - Ícono de avión (fa-plane)
 * - Nombre de la aerolínea
 * - Código IATA entre paréntesis en negrita
 *
 * @example
 * // Retorna: HTML con "Cubana de Aviación (CU)"
 * this._myListFormatterAirline({name: 'Cubana de Aviación', iata: 'CU'});
 */
  _myListFormatterAirline = (data: any) => {

      const html = `<span class='fa fa-plane'style='color:#a9a4a4'>
      </span>
      <span style='font-size:15px;cursor:pointer;line-height:2.1;'>
        ${ data['name']}
      </span>
      <span style=' font-weight: 500;font-size:14px;color:black'>
       (${data['iata']})
      </span>`;

    return this._sanitizer.bypassSecurityTrustHtml(html);

  }

/**
 * Capitaliza cada palabra de una cadena de texto
 *
 * Este método utility convierte una cadena a formato de título, capitalizando
 * la primera letra de cada palabra y poniendo el resto en minúsculas.
 *
 * @param {any} val - Valor a capitalizar (se convierte a string)
 * @returns {string} - Cadena capitalizada
 *
 * @transformation
 * 1. Convierte a minúsculas
 * 2. Elimina espacios en blanco al inicio y final
 * 3. Divide por espacios
 * 4. Capitaliza cada palabra
 * 5. Une con espacios
 *
 * @example
 * // Retorna: "José Martí International Airport"
 * this.capitalize("josé martí international airport");
 *
 * @example
 * // Retorna: "New York"
 * this.capitalize("NEW YORK");
 */
  capitalize(val: any) {
    return val.toLowerCase()
            .trim()
            .split(' ')
            .map( v => v[0].toUpperCase() + v.substr(1) )
            .join(' ');
  }

  /**
 * Callback para manejar la selección de aeropuerto de entrada
 *
 * Este método se ejecuta cuando se selecciona un aeropuerto en componentes de entrada
 * y actualiza las propiedades relacionadas con el aeropuerto de llegada.
 *
 * @param {any} data - Objeto con datos del aeropuerto seleccionado
 * @param {number} data.id - ID del aeropuerto
 * @param {string} data.country_code - Código de país del aeropuerto
 * @param {string} data.iata - Código IATA del aeropuerto
 * @param {string} data.nameAirport - Nombre del aeropuerto
 * @param {string} data.codeIataAirport - Código IATA del aeropuerto (alternativo)
 *
 * @returns {string} - Cadena formateada para display: "Nombre (IATA) (IATA)"
 *
 * @sideEffects
 * - Actualiza selectedAirportInId con el ID del aeropuerto
 * - Actualiza selectedAirportInCountryCode con el código de país
 * - Actualiza selectedAirportIn con el código IATA
 *
 * @condition
 * - Si hay payloadSearch y es categoría 8 con pickupLocation tipo 'airport',
 *   aplica lógica específica de transfers
 *
 * @example
 * // Retorna: "José Martí (HAV) (HAV)"
 * this._myCallbackAirportIn({
 *   id: 123,
 *   country_code: 'CU',
 *   iata: 'HAV',
 *   nameAirport: 'José Martí',
 *   codeIataAirport: 'HAV'
 * });
 */
  _myCallbackAirportIn(data: any): string {
    if (data) {
      this.selectedAirportInId = data['id'];
      this.selectedAirportInCountryCode = data['country_code'];
      this.selectedAirportIn = data['iata']; // codeIataCity
      this.selectedAirportInCityName = data['city_name'] ?? '';
     return `${data['nameAirport']} (${data['codeIataAirport']}) (${data['codeIataAirport']})`;
    }
  }

  /**
 * Callback para manejar la selección de aeropuerto de salida
 *
 * Este método se ejecuta cuando se selecciona un aeropuerto en componentes de salida
 * y actualiza las propiedades relacionadas con el aeropuerto de partida.
 *
 * @param {any} data - Objeto con datos del aeropuerto seleccionado
 * @param {string} data.name - Nombre del aeropuerto
 * @param {string} data.iata - Código IATA del aeropuerto
 * @param {string} data.country_code - Código de país del aeropuerto
 *
 * @returns {string} - Cadena formateada para display: "Nombre (IATA)"
 *
 * @sideEffects
 * - Actualiza selectedAirportOut con el código IATA
 * - En condiciones específicas de transfers, actualiza propiedades de aeropuerto de entrada
 *
 * @condition
 * - Si hay payloadSearch, es categoría 8, pickupLocation no es 'airport'
 *   y dropoffLocation es 'airport', actualiza propiedades de aeropuerto de entrada
 *
 * @example
 * // Retorna: "Juan Gualberto Gómez (VRA)"
 * this._myCallbackAirportOut({
 *   name: 'Juan Gualberto Gómez',
 *   iata: 'VRA',
 *   country_code: 'CU'
 * });
 */
  _myCallbackAirportOut(data: any): string {
   if (data) {
    this.selectedAirportInCountryCode = data['country_code'];
    // this.selectedAirportIn = data['iata']; // codeIataCity
    this.selectedAirportOut =  data['iata']; //his._airportOut['codeIataAirport'];
    this.selectedAirportOutCityName = data['city_name'] ?? '';
    return `${data['name']} (${data['iata']})`;
   }
  }

  /**
 * Callback para manejar la selección de aerolínea de entrada
 *
 * Este método se ejecuta cuando se selecciona una aerolínea en componentes de entrada
 * y actualiza las propiedades relacionadas con la aerolínea de llegada.
 *
 * @param {any} data - Objeto con datos de la aerolínea seleccionada
 * @param {string} data.name - Nombre de la aerolínea
 * @param {string} data.iata - Código IATA de la aerolínea
 *
 * @returns {string} - Cadena formateada para display: "Nombre (IATA)"
 *
 * @sideEffects
 * - Actualiza selectedAirlineIn con el código IATA de la aerolínea
 * - Actualiza valueAirlineCodeIata con el código IATA seleccionado
 * - Parchea el formulario _formFlights con _flightNumberIn
 *
 * @example
 * // Retorna: "Cubana de Aviación (CU)"
 * this._myCallbackAirlineIn({
 *   name: 'Cubana de Aviación',
 *   iata: 'CU'
 * });
 */
  _myCallbackAirlineIn(data: any): string {
    if (data) {
      this.selectedAirlineIn = data['iata'];
      this.selectedAirlineInName = data['name'];
      this.valueAirlineCodeIata = this.selectedAirlineIn;
      this._formFlights.patchValue({
        _flightNumberIn:  this.selectedAirlineIn,
      });
      return `${data['name']} (${data['iata']})`;
    }
  }

  /**
 * Callback para manejar la selección de aerolínea de salida
 *
 * Este método se ejecuta cuando se selecciona una aerolínea en componentes de salida
 * y actualiza las propiedades relacionadas con la aerolínea de partida.
 *
 * @param {any} data - Objeto con datos de la aerolínea seleccionada
 * @param {string} data.name - Nombre de la aerolínea
 * @param {string} data.iata - Código IATA de la aerolínea
 *
 * @returns {string} - Cadena formateada para display: "Nombre (IATA)"
 *
 * @sideEffects
 * - Actualiza selectedAirlineOut con el código IATA de la aerolínea
 * - Parchea el formulario _formFlights con _flightNumberOut
 *
 * @example
 * // Retorna: "American Airlines (AA)"
 * this._myCallbackAirlineOut({
 *   name: 'American Airlines',
 *   iata: 'AA'
 * });
 */
  _myCallbackAirlineOut(data: any): string {
   if (data) {
     this.selectedAirlineOut = data['iata'];
     this.selectedAirlineOutName = data['name'];
     this._formFlights.patchValue({
       _flightNumberOut:  this.selectedAirlineOut,
     });
    return `${data['name']} (${data['iata']})`;
   }
  }

  /**
 * Callback para manejar la selección de ciudad IATA de entrada
 *
 * Este método se ejecuta cuando se selecciona una ciudad en componentes de entrada
 * y actualiza las propiedades relacionadas con la ciudad de origen del vuelo.
 *
 * @param {any} data - Objeto con datos de la ciudad seleccionada
 * @param {string} data.city_name - Nombre de la ciudad
 * @param {string} data.country_name - Nombre del país
 * @param {string} data.city_iata_code - Código IATA de la ciudad
 *
 * @returns {string} - Cadena formateada para display: "Ciudad, País"
 *
 * @sideEffects
 * - Actualiza selectedCityIataInName con "Ciudad, País"
 * - Actualiza selectedCityIataIn con el código IATA de la ciudad
 * - Actualiza valueCityCodeIataIn con el código IATA seleccionado
 * - Parchea el formulario _formFlights con cityDepartureIn
 *
 * @example
 * // Retorna: "La Habana, Cuba"
 * this._myCallbackCityIataIn({
 *   city_name: 'La Habana',
 *   country_name: 'Cuba',
 *   city_iata_code: 'HAV'
 * });
 */
    _myCallbackCityIataIn(data: any): string {

    if (data) {
      this.selectedCityIataInName = `${data['city_name']}, ${data['country_name']}`;
      this.selectedCityIataIn = data['city_iata_code'];
      this.valueCityCodeIataIn = this.selectedCityIataIn;
      this._formFlights.patchValue({
        cityDepartureIn:  this.selectedCityIataIn,
      });
      return `${data['city_name']}, ${data['country_name']}`;
    }
  }

  /**
 * Callback para manejar la selección de ciudad IATA de salida
 *
 * Este método se ejecuta cuando se selecciona una ciudad en componentes de salida
 * y actualiza las propiedades relacionadas con la ciudad de destino del vuelo.
 *
 * @param {any} data - Objeto con datos de la ciudad seleccionada
 * @param {string} data.city_name - Nombre de la ciudad
 * @param {string} data.country_name - Nombre del país
 * @param {string} data.city_iata_code - Código IATA de la ciudad
 *
 * @returns {string} - Cadena formateada para display: "Ciudad, País"
 *
 * @sideEffects
 * - Actualiza selectedIataCityArrivalOutName con "Ciudad, País"
 * - Actualiza selectedIataCityArrivalOut con el código IATA de la ciudad
 * - Actualiza valueCityCodeIataOut con el código IATA seleccionado
 * - Parchea el formulario _formFlights con iataCityArrivalOut
 *
 * @example
 * // Retorna: "Miami, Estados Unidos"
 * this._myCallbackCityIataOut({
 *   city_name: 'Miami',
 *   country_name: 'Estados Unidos',
 *   city_iata_code: 'MIA'
 * });
 */
  _myCallbackCityIataOut(data: any): string {
    if (data) {
      this.selectedIataCityArrivalOutName = `${data['city_name']}, ${data['country_name']}`;
      this.selectedIataCityArrivalOut = data['city_iata_code'];
      this.valueCityCodeIataOut = this.selectedIataCityArrivalOut;
      this._formFlights.patchValue({
        iataCityArrivalOut:  this.selectedIataCityArrivalOut,
      });
      return `${data['city_name']}, ${data['country_name']}`;
    }
  }

  /**
 * Factory function que retorna una función de autocompletado para aeropuertos o aerolíneas
 *
 * Este método genera funciones de búsqueda para componentes de autocompletado que
 * se conectan con el servicio de ubicaciones para obtener datos en tiempo real.
 *
 * @param {'airport' | 'airline'} type - Tipo de búsqueda: 'airport' o 'airline'
 * @returns {(keyword: string) => Observable<any[]>} - Función que recibe keyword y retorna Observable con resultados
 *
 * @uses ubicacionesService.getAirportsAirlines - Servicio para obtener datos de aeropuertos/aerolíneas
 *
 * @example
 * // Uso en componente de autocompletado:
 * const airportSource = this.getAutoCompleteSource('airport');
 * airportSource('hav').subscribe(results => {...});
 *
 * @example
 * // Uso con aerolíneas:
 * const airlineSource = this.getAutoCompleteSource('airline');
 * airlineSource('cub').subscribe(results => {...});
 */
  getAutoCompleteSource(type: 'airport' | 'airline'): (keyword: string) => Observable<any[]> {
    return (keyword: string) => {
      return this.ubicacionesService.getAirportsAirlines(keyword, type);
    };
  }

  get hasReservedItem(): boolean {
    const items = this._actualItinerary?.items;
    return Array.isArray(items) && items.some(
      (i: any) => i?.status_id === 2 || i?.status_id === 3
    );
  }

  get datePickerConfig(): Partial<BsDatepickerConfig> {
    // Spread not allowed in Angular templates; merge here instead.
    // `useUtc: true` keeps bsDatepicker consistent with our UTC-parsed FormControls,
    // preventing the picker from re-interpretting the day in the browser's tz.
    // ngx-bootstrap 7.x reads `useUtc` from the config object at runtime, but
    // the typings for BsDatepickerConfig do not declare it, so we cast through any.
    return { ...this.dpConfig, isDisabled: this.hasReservedItem, useUtc: true } as Partial<BsDatepickerConfig>;
  }

  /**
   * Per-control bsDatepicker config. The bsDatepicker reads `isDisabled` from
   * `bsConfig` to suppress the calendar dropdown — simply disabling the
   * FormControl is not enough to block the picker. Each date control needs
   * its own config object so the locked state is independent.
   */
  get arrivalDateInConfig(): Partial<BsDatepickerConfig> {
    return {
      ...this.dpConfig,
      isDisabled: this.hasReservedItem || this.isDateLocked('arrivalDateIn'),
      useUtc: true,
    } as Partial<BsDatepickerConfig>;
  }

  get departureDateOutConfig(): Partial<BsDatepickerConfig> {
    return {
      ...this.dpConfig,
      isDisabled: this.hasReservedItem || this.isDateLocked('departureDateOut'),
      useUtc: true,
    } as Partial<BsDatepickerConfig>;
  }

  get effectiveFlightsForSummary(): any[] {
    const flights = Array.isArray(this.flightsInternal) && this.flightsInternal.length > 0
      ? this.flightsInternal
      : this._actualItinerary?.flights;

    return Array.isArray(flights)
      ? flights.filter(flight => !this._isGeneralFlight(flight))
      : [];
  }

  /**
 * Factory function que retorna una función de autocompletado para destinos (ciudades)
 *
 * Este método genera funciones de búsqueda para componentes de autocompletado que
 * se conectan con el servicio de ubicaciones para obtener datos de ciudades en tiempo real.
 *
 * @param {string} [keyoword] - Parámetro opcional (posible typo de 'keyword')
 * @returns {(keyword: string) => Observable<any[]>} - Función que recibe keyword y retorna Observable con resultados de ciudades
 *
 * @uses ubicacionesService.getCitys - Servicio para obtener datos de ciudades
 * @uses map() - Operador RxJS para transformar la respuesta
 *
 * @transformation
 * - Filtra la respuesta para encontrar el objeto con type === 'city'
 * - Retorna el array cities o un array vacío si no existe
 *
 * @example
 * // Uso en componente de autocompletado:
 * const citySource = this.getAutoCompleteSourceDestination();
 * citySource('hav').subscribe(cities => {...});
 */
  getAutoCompleteSourceDestination(keyoword?: string): (keyword: string) => Observable<any[]> {
    return (keyword: string) => {
      return this.ubicacionesService.getCitys(keyword).pipe(
        map((response: any) => {
          // Retorna solo el array hotels de la respuesta
          return response.find(r  => r.type === 'city')?.cities || []; // Usa array vacío si hotels no existe
        })
      );
    };
  }
/**
 * Formatea la visualización de destinos (ciudades) en listas desplegables
 *
 * Este método genera HTML seguro para mostrar información de ciudades en formatos
 * personalizados dentro de componentes de autocompletado o selección.
 *
 * @param {any} data - Objeto con los datos de la ciudad
 * @param {string} data.city_name - Nombre de la ciudad
 * @param {string} data.country_name - Nombre del país
 *
 * @returns {SafeHtml} - HTML sanitizado y seguro para renderizar
 *
 * @uses DomSanitizer.bypassSecurityTrustHtml - Para permitir HTML seguro
 *
 * @format
 * - Ícono de marcador de mapa (fa-map-marker)
 * - Nombre de la ciudad seguido de coma
 * - Nombre del país en negrita
 *
 * @example
 * // Retorna: HTML con "La Habana, Cuba"
 * this._myListFormatterDestination({
 *   city_name: 'La Habana',
 *   country_name: 'Cuba'
 * });
 */
    _myListFormatterDestination = (data: any) => {

      const html = `<span class='fa fa-map-marker'style='color:#a9a4a4'>
      </span>
      <span style='font-size:15px;cursor:pointer;line-height:2.1;'>
        ${ data['city_name']},
      </span>
      <span style=' font-weight: 500;font-size:14px;color:black'>
        ${data['country_name']}
      </span>`;

    return this._sanitizer.bypassSecurityTrustHtml(html);

  }


  /***********************************************Auto Complete********************************************/

  /**
 * Reinicia el formulario de vuelos a su estado inicial y limpia selecciones
 *
 * Este método restablece todos los controles del formulario y elimina las opciones
 * seleccionadas en los campos de aeropuertos y aerolíneas.
 *
 * @returns {void}
 *
 * @actions
 * 1. Resetea todos los valores del formulario _formFlights
 * 2. Limpia las selecciones de aeropuertos y aerolíneas mediante deleteSelectedOption
 *
 * @uses deleteSelectedOption() - Método para limpiar selecciones específicas
 *
 * @example
 * // Reiniciar formulario completo:
 * this.resetForm();
 */
  resetForm ()  {
    this._formFlights.reset();
    this.deleteSelectedOption('airportIn');
    this.deleteSelectedOption('airlineIn');
    this.deleteSelectedOption('airportOut');
    this.deleteSelectedOption('airlineOut');
  }

  /**
 * Inicializa el formulario de vuelos con configuraciones condicionales basadas en el contexto
 *
 * Este método configura dinámicamente el formulario de vuelos según diferentes escenarios:
 * - Transferencias one-way vs round-trip
 * - Vuelos de entrada only vs vuelos de salida only vs formulario completo
 * - Estados disabled para ciertos controles según el contexto
 *
 * @logic
 * Primero verifica si existe payloadSearch con categoría 8 (transfers):
 * - Configura formulario parcial para one-way transfers
 * - Configura formulario completo para round-trip transfers
 *
 * Si no hay payloadSearch, verifica flyShowComponent:
 * - Configura formulario parcial según vuelos existentes
 * - Configura formulario completo por defecto
 *
 * @uses subscribeFormCheckDatesIn() - Suscribe validaciones de fechas para vuelos de entrada
 * @uses subscribeFormCheckDatesOut() - Suscribe validaciones de fechas para vuelos de salida
 * @uses initFullForm() - Inicializa formulario completo con todos los controles
 *
 * @states
 * - onlyIn: true → Solo formulario de vuelo de entrada
 * - onlyOut: true → Solo formulario de vuelo de salida
 * - Ambos true → Formulario completo pero con controles disabled
 *
 * @disabledControls
 * Controles se deshabilitan según el tipo de transferencia o estado del vuelo
 */
    _initFlightsForm() {
    // Dispatch to a per-case configurator. Each branch owns the flag
    // mutations, the form construction, and the post-init sync
    // (hour controls + date listeners) for its scenario.
    if (this._hasRoundTripAirportBothEnds()) {
      this._configureRoundTripAirportBothEnds();
      return;
    }

    if (this._isTransfersPayload()) {
      this._configureTransfersForm();
      return;
    }

    if (this._isArrivalOnlyPartial()) {
      this._configureArrivalOnlyPartial();
      return;
    }

    if (this._isDepartureOnlyPartial()) {
      this._configureDepartureOnlyPartial();
      return;
    }

    // Full form (non-transfers / round-trip default).
    this._configureDefaultFullForm();
  }

  /**
   * Common post-init steps shared by every full-form branch: sync hour
   * controls to the freshly built FormGroup and rewire the date listeners.
   * The arrival-only and departure-only branches skip this because they
   * manage their own date listeners via subscribeFormCheckDates*().
   */
  private _finalizeFullFormInit(): void {
    this._syncHourControls();
    if (this._actualItinerary?.flights?.length === 0) {
      this._rewireDateListeners();
    } else {
      setTimeout(() => this._rewireDateListeners(), 800);
    }
  }

  private _configureRoundTripAirportBothEnds(): void {
    this.onlyIn = true;
    this.onlyOut = true;
    this.legUnlocked = true;
    this.isTransfersContext = true;
    this.isRotatedSwap = false;
    this.initFullForm();
    this.setLegVisible('in', true);
    this.setLegVisible('out', true);
    this._finalizeFullFormInit();
  }

  private _configureTransfersForm(): void {
    const { onlyIn, onlyOut, legUnlocked } = this._resolveTransferLegFlags();
    this.onlyIn = onlyIn;
    this.onlyOut = onlyOut;
    this.legUnlocked = legUnlocked;
    this.isTransfersContext = true;
    this.isRotatedSwap = false;
    this.initFullForm();
    this.setLegVisible('in', this.onlyIn);
    this.setLegVisible('out', this.onlyOut);
    this._finalizeFullFormInit();
  }

  private _configureArrivalOnlyPartial(): void {
    this.onlyIn = true;
    this._formFlights = this._buildArrivalOnlyForm();
    this._formFlights.get('departureHourIn')?.disable();
    this._formFlights.get('arrivalHourIn')?.disable();
    this._formRebuild$.next();
    this.subscribeFormCheckDatesIn();
  }

  private _configureDepartureOnlyPartial(): void {
    this.onlyOut = true;
    this._formFlights = this._buildDepartureOnlyForm();
    this._formFlights.get('departureDateOut')?.disable();
    this._formFlights.get('departureHourOut')?.disable();
    this._formFlights.get('arrivalDateOut')?.disable();
    this._formFlights.get('arrivalHourOut')?.disable();
    this._formRebuild$.next();
    this.subscribeFormCheckDatesOut();
  }

  private _configureDefaultFullForm(): void {
    this.onlyIn = true;
    this.onlyOut = true;
    this.initFullForm();
    this._finalizeFullFormInit();
  }

  private _isTransfersPayload(): boolean {
    return !!(this.payloadSearch && this.payloadSearch[0]?.categoriesId?.[0] === 8);
  }

  private _isArrivalOnlyPartial(): boolean {
    return !!(this.flyShowComponent?.fly?.arrivalDateIn && !this.flyShowComponent?.fly?.arrivalDateOut);
  }

  private _isDepartureOnlyPartial(): boolean {
    return !!(this.flyShowComponent?.fly?.arrivalDateOut && !this.flyShowComponent?.fly?.arrivalDateIn);
  }

  /**
   * Returns the visibility flags for the arrival/departure legs when the
   * form was opened from a transfers search payload. Round-trip transfers
   * expose both legs; otherwise each leg is visible if its endpoint is
   * an airport, with a fallback so one leg is always shown.
   */
  private _resolveTransferLegFlags(): { onlyIn: boolean; onlyOut: boolean; legUnlocked: boolean } {
    const transfers = this.payloadSearch[0].transfers;
    const pickupType = transfers?.pickupLocation?.type;
    const dropoffType = transfers?.dropoffLocation?.type;
    const hasPickupAirport =
      pickupType === 'airport' && !!transfers?.pickupLocation?.address;
    const hasDropoffAirport =
      dropoffType === 'airport' && !!transfers?.dropoffLocation?.address;
    const isRoundTripTransfer = transfers?.oneWay === false;

    if (isRoundTripTransfer) {
      return { onlyIn: true, onlyOut: true, legUnlocked: true };
    }

    const onlyIn = hasPickupAirport || !hasDropoffAirport;
    const onlyOut = hasDropoffAirport || !hasPickupAirport;
    return { onlyIn, onlyOut, legUnlocked: onlyIn && onlyOut };
  }

  private _buildArrivalOnlyForm(): FormGroup {
    return this._formBuilder.group({
      airlineIn: new FormControl(null, Validators.required),
      _flightNumberIn: new FormControl(null, Validators.required),
      flightNumberIn: new FormControl(null, [Validators.required, Validators.minLength(3)]),
      arrivalDateIn: new FormControl(null, Validators.required),
      arrivalHourIn: new FormControl(null, [Validators.required, Validators.pattern(/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/)]),
      airportIn: new FormControl(null, Validators.required),
    });
  }

  private _buildDepartureOnlyForm(): FormGroup {
    return this._formBuilder.group({
      airlineOut: new FormControl(null, Validators.required),
      _flightNumberOut: new FormControl(null, Validators.required),
      flightNumberOut: new FormControl(null, [Validators.required, Validators.minLength(3)]),
      departureDateOut: new FormControl(null, Validators.required),
      departureHourOut: new FormControl(null, [Validators.required, Validators.pattern(/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/)]),
      airportOut: new FormControl(null, Validators.required),
    });
  }

  /**
 * Inicializa el formulario completo de vuelos con todos los controles y validaciones
 *
 * Este método crea el formulario reactivo con todos los campos necesarios para
 * vuelos de ida y vuelta (round-trip) con sus respectivas validaciones.
 *
 * @returns {void}
 *
 * @structure
 * Grupo de controles para vuelo de entrada (in):
 * - airlineIn: Aerolínea de entrada (requerido)
 * - _flightNumberIn: Número de vuelo interno (requerido)
 * - flightNumberIn: Número de vuelo (requerido, min 3 caracteres)
 * - cityDepartureIn: Ciudad de salida (requerido)
 * - departureDateIn: Fecha de salida (requerido)
 * - departureHourIn: Hora de salida (requerido)
 * - arrivalDateIn: Fecha de llegada (requerido)
 * - arrivalHourIn: Hora de llegada (requerido)
 * - airportIn: Aeropuerto de entrada (requerido)
 *
 * Grupo de controles para vuelo de salida (out):
 * - airlineOut: Aerolínea de salida (requerido)
 * - _flightNumberOut: Número de vuelo interno (requerido)
 * - flightNumberOut: Número de vuelo (requerido, min 3 caracteres)
 * - iataCityArrivalOut: Ciudad de llegada IATA (requerido)
 * - departureDateOut: Fecha de salida (requerido)
 * - departureHourOut: Hora de salida (requerido)
 * - arrivalDateOut: Fecha de llegada (requerido)
 * - arrivalHourOut: Hora de llegada (requerido)
 * - airportOut: Aeropuerto de salida (requerido)
 *
 * @validations
 * - Todos los campos son requeridos
 * - flightNumberIn/Out tienen validación de longitud mínima (3 caracteres)
 *
 * @example
 * // Inicializar formulario completo:
 * this.initFullForm();
 */
  initFullForm(): void {
   this._formFlights = this._formBuilder.group({
      //in
      airlineIn: new FormControl(null, Validators.required),
      _flightNumberIn: new FormControl(null, Validators.required),
      flightNumberIn: new FormControl(null, [Validators.required, Validators.minLength(3)]),
      arrivalDateIn: new FormControl(null, Validators.required),
      arrivalHourIn: new FormControl(null, Validators.required),
      airportIn: new FormControl(null, Validators.required),
      //out
      airlineOut: new FormControl(null, Validators.required),
      _flightNumberOut: new FormControl(null, Validators.required),
      flightNumberOut: new FormControl(null,[Validators.required, Validators.minLength(3)]),
      departureDateOut: new FormControl(null, Validators.required),
      departureHourOut: new FormControl(null, Validators.required),
      airportOut: new FormControl(null, Validators.required)
   })
  }

  /**
 * Parchea el formulario de vuelos con datos existentes de un vuelo
 *
 * Este método complejo llena el formulario con datos de un vuelo existente, manejando
 * múltiples escenarios según el contexto (results vs fly) y origen de los datos.
 *
 * @param {any} [infoFly] - Objeto opcional con información del vuelo a editar
 * @returns {void}
 *
 * @contexts
 * - Si component === 'results': Usa flight del itinerario actual
 * - Si component === 'fly': Usa infoFly proporcionado
 *
 * @scenarios
 * 1. Edición de vuelo existente (con flight.id):
 *    - Completa todos los campos del formulario con datos del vuelo
 *    - Realiza búsquedas adicionales para información de ciudades
 *    - Configura fechas y horas con parsing especializado
 *
 * 2. Nuevo vuelo con datos de transfers (payloadSearch):
 *    - Prellena campos basado en información de transfers
 *    - Configura fechas basado en firstArrivalDate de transfers
 *    - Ajusta tiempos restando 1 minuto para validaciones
 *
 * @operations
 * - Setea valores en controles del formulario
 * - Actualiza propiedades del componente (selectedAirportIn, etc.)
 * - Realiza llamadas a servicios para obtener datos de ciudades
 * - Parsea y formatea fechas y horas
 * - Maneja escenarios oneWay vs round-trip
 *
 * @uses parseLocalDateTime() - Para parsing de fechas desde strings
 * @uses _extractHourMinute() - Para extraer hora de objetos Date
 * @uses ubicacionesService.getCitys() - Para búsqueda de información de ciudades
 *
 * @sideEffects
 * - Actualiza multiple properties del componente
 * - Realiza suscripciones a observables
 * - Ejecuta change detection manualmente
 */
patchForm(infoFly?: any): void {
    this.maxDateDepartureDateIn = null;

    // Re-enable controls that `_initFlightsForm` may have left disabled.
    // patchValue on a disabled FormControl silently drops the value in some
    // Angular versions, which would leave `arrivalHourIn` null and break the
    // submit gate. We patch, then re-disable at the end of this method.
    this._reEnableDateAndHourControls();

    const flight = this._resolveFlightSource(infoFly);
    this._applyLegVisibility(flight);

    if (flight && flight?.id) {
      this._patchFromExistingFlight(flight);
    } else if (
      this.payloadSearch &&
      this.payloadSearch.length > 0 &&
      this.formTransports
    ) {
      this._patchFromTransfersPayload(this.payloadSearch[0]);
    }

    this._finalizePatch();
  }

  /**
   * Common post-patch steps: sync hour controls to the freshly patched
   * FormGroup, run change detection, capture the airport/date snapshots
   * that drive isAirportLocked / isDateLocked, and mark the prefill as
   * applied so subsequent lifecycle hooks can detect it.
   */
  private _finalizePatch(): void {
    // Restore the enabled/disabled state from the patched dates and visible legs.
    this._syncHourControls();
    this.cdr.detectChanges();
    // Snapshot the airport/date values so isAirportLocked() and
    // isDateLocked() can tell whether the user has touched the field
    // since the form opened. Drives the readonly vs. autocomplete branch
    // in the template.
    this.captureInitialAirportValues();
    this.captureInitialDateValues();
    this._prefillApplied = true;
  }

  private _reEnableDateAndHourControls(): void {
    const controls = [
      'arrivalHourIn', 'departureHourIn',
      'arrivalHourOut', 'departureHourOut',
      'arrivalDateIn', 'departureDateOut',
      'arrivalDateOut',
    ];
    controls.forEach(name =>
      this._formFlights.get(name)?.enable({ emitEvent: false })
    );
  }

  /**
   * Resolves which flight object to use as the source of truth for the
   * patch. Priority: explicit `infoFly` argument > `_actualItinerary`'s
   * first flight (for `results` context) > same with fallback to `infoFly`
   * (for `fly` context).
   */
  private _resolveFlightSource(infoFly?: any): any {
    if (infoFly) {
      // Explicit flight passed (e.g. from openModalWithClass with cached data).
      return infoFly;
    }
    if (this.component === 'results') {
      return this._actualItinerary?.flights[0];
    }
    if (this.component === 'fly') {
      return this._actualItinerary?.flights?.length > 0
        ? this._actualItinerary.flights[0]
        : infoFly;
    }
    return undefined;
  }

  /**
   * Sets onlyIn / onlyOut / legUnlocked based on the loaded flight and
   * the search payload. When neither applies (no flight, no round-trip
   * transfer payload), leaves the flags alone — `_initFlightsForm()` has
   * already set them according to the leg visibility it computed.
   */
  private _applyLegVisibility(flight: any): void {
    // Existing flight with id: arrival always shown, departure only if
    // the saved flight has a departureOut.
    if (flight && flight?.id) {
      this.onlyIn = true;
      this.onlyOut = !!flight?.departureOut;
      this.legUnlocked = !!flight?.departureOut;
      return;
    }
    if (this._isRoundTripTransferPayload()) {
      this.onlyIn = true;
      this.onlyOut = true;
      this.legUnlocked = true;
    }
  }

  private _isRoundTripTransferPayload(): boolean {
    return !!(
      this.payloadSearch &&
      Array.isArray(this.payloadSearch) &&
      this.payloadSearch.length > 0 &&
      this.payloadSearch[0]?.categoriesId?.[0] === 8 &&
      this.payloadSearch[0]?.transfers?.oneWay === false
    );
  }

  private _patchFromExistingFlight(flight: any): void {
    if (flight?.arrivalIn) {
      this._patchArrivalLegFromFlight(flight);
    }
    if (flight?.departureOut) {
      this._patchDepartureLegFromFlight(flight);
    }
  }

  private _patchArrivalLegFromFlight(flight: any): void {
    this.selectedAirportIn = flight?.airportIataCodeIn;
    this.selectedAirportInCountryCode = flight?.iata_code;
    this.selectedAirportInId = flight?.id_airport;
    this._formFlights.get('airportIn')?.setValue({ name: flight.airportIn });
    this._formFlights.get('airlineIn')?.setValue({
      name: flight?.airlineIn,
      iata: flight?.airlineIataCodeIn,
    });
    this.selectedAirlineInName = flight?.airlineIn;

    const departureIn = this.parseLocalDateTime(flight?.departureIn);
    const arrivalIn = this.parseLocalDateTime(flight?.arrivalIn);
    this._formFlights.patchValue({
      _flightNumberIn: flight?.airlineIataCodeIn || null,
      flightNumberIn: flight.flyNumberIn || null,
      departureHourIn: departureIn
        ? this._extractHourMinute(departureIn.toString())
        : null,
    });
    this._formFlights.patchValue({
      arrivalDateIn: arrivalIn || null,
      arrivalHourIn: arrivalIn
        ? this._extractHourMinute(arrivalIn.toString())
        : null,
    });
  }

  private _patchDepartureLegFromFlight(flight: any): void {
    const departureOut = this.parseLocalDateTime(flight?.departureOut);
    const arrivalOut = this.parseLocalDateTime(flight?.arrivalOut);

    this.selectedAirportOut = flight?.airportIataCodeOut;
    this._formFlights.get('airportOut')?.setValue({
      name: flight?.airportOut,
      iata: flight?.airportIataCodeOut,
    });
    this._formFlights.get('airlineOut')?.setValue({
      name: flight?.airlineOut,
      iata: flight?.airlineIataCodeOut,
    });
    this.selectedAirlineOutName = flight?.airlineOut;

    this._formFlights.patchValue({
      _flightNumberOut: flight?.airlineIataCodeOut || null,
      flightNumberOut: flight.flyNumberOut || null,
      departureDateOut: departureOut || null,
      departureHourOut: departureOut
        ? this._extractHourMinute(departureOut.toString())
        : null,
    });
    this._formFlights.patchValue({
      arrivalDateOut: arrivalOut || null,
      arrivalHourOut: arrivalOut
        ? this._extractHourMinute(arrivalOut.toString())
        : null,
    });
  }

  private _patchFromTransfersPayload(transferPayload: any): void {
    const transfers = transferPayload?.transfers;
    if (!transfers) {
      return;
    }
    this._patchArrivalLegFromTransfers(transfers, transferPayload);
    this._patchDepartureLegFromTransfers(transfers, transferPayload);
  }

  private _patchArrivalLegFromTransfers(transfers: any, transferPayload: any): void {
    if (transfers?.pickupLocation?.type === 'airport') {
      const pickupLocation = transfers.pickupLocation;
      this.selectedAirportIn = pickupLocation.address || null;
      this.selectedAirportInCountryCode =
        this.formTransports?.firstOrigin?.country_code || null;
      this.selectedAirportInId = pickupLocation.id || null;
      this._formFlights.get('airportIn')?.setValue({
        name:
          this.formTransports?.firstOrigin?.name ||
          pickupLocation.name ||
          null,
        iata: pickupLocation.address || null,
      });

      const arrivalDate = this._getTransferDateTime(
        this.formTransports?.firstArrivalDate || transferPayload.pickupDate,
        this.formTransports?.firstTime || transfers.pickupTime
      );
      if (arrivalDate) {
        // Subtract one minute so the arrival time falls within the
        // transfer pickup window's tolerance.
        arrivalDate.setMinutes(arrivalDate.getMinutes() - 1);
        this._patchDateTime('arrivalDateIn', 'arrivalHourIn', arrivalDate);
      }
      return;
    }

    // Reverse direction (hotel → airport, hotel → hotel, etc.): the arrival
    // airport is the destination of the journey, which is the dropoff. When
    // pickup is not an airport but dropoff is, we still want to fill the
    // arrival form with the dropoff's airport data.
    if (
      transfers?.pickupLocation?.type !== 'airport' &&
      transfers?.dropoffLocation?.type === 'airport' &&
      transfers?.dropoffLocation
    ) {
      const reversedDropoff = transfers.dropoffLocation;
      this.selectedAirportIn = reversedDropoff.address || null;
      this.selectedAirportInCountryCode =
        this.formTransports?.firstDestination?.country_code || null;
      this.selectedAirportInId = reversedDropoff.id || null;
      this._formFlights.get('airportIn')?.setValue({
        name:
          this.formTransports?.firstDestination?.name ||
          reversedDropoff.name ||
          null,
        iata: reversedDropoff.address || null,
      });

      const arrivalDate = this._getTransferDateTime(
        this.formTransports?.firstArrivalDate || transferPayload.pickupDate,
        this.formTransports?.firstTime || transfers.pickupTime
      );
      if (arrivalDate) {
        this._patchDateTime('arrivalDateIn', 'arrivalHourIn', arrivalDate);
      }
    }
  }

  private _patchDepartureLegFromTransfers(transfers: any, transferPayload: any): void {
    const dropoffLocation = transfers?.dropoffLocation;
    if (!dropoffLocation || (!dropoffLocation.name && !dropoffLocation.address)) {
      return;
    }

    // For non-airport pickups, populate selectedAirportIn* from the
    // dropoff so the UI shows the right airport metadata.
    if (transfers?.pickupLocation?.type !== 'airport') {
      this.selectedAirportInCountryCode =
        this.formTransports?.firstDestination?.country_code || null;
      this.selectedAirportInId = dropoffLocation.id || null;
    }

    const isRoundTrip =
      transfers?.oneWay === false ||
      transferPayload?.transfers?.oneWay === false;

    // For round-trips where the dropoff is not an airport (hotel,
    // address, etc.) we fall back to the airport of arrival so the
    // outbound form shows a sensible airport code. For one-way trips or
    // airport-to-airport round-trips, the dropoff itself is the right
    // value to use.
    const airportInValue = this._formFlights.get('airportIn')?.value;
    const useArrivalAirportForOutbound =
      isRoundTrip && dropoffLocation.type !== 'airport';

    const outName = useArrivalAirportForOutbound
      ? airportInValue?.name || dropoffLocation.name
      : this.formTransports?.firstDestination?.name || dropoffLocation.name;
    const outIata = useArrivalAirportForOutbound
      ? airportInValue?.iata || dropoffLocation.address
      : dropoffLocation.address;

    // Only mark `selectedAirportOut` if the dropoff is actually an
    // airport or we're falling back to the arrival airport. For
    // one-way trips or hotel/address dropoffs we leave `airportOut`
    // empty — the outbound flight form is irrelevant in those cases.
    if (dropoffLocation.type === 'airport') {
      this.selectedAirportOut = dropoffLocation.address || null;
      this._formFlights.get('airportOut')?.setValue({
        name: outName || null,
        iata: outIata || null,
      });
    } else if (useArrivalAirportForOutbound) {
      this.selectedAirportOut = airportInValue?.iata || null;
      this._formFlights.get('airportOut')?.setValue({
        name: outName || null,
        iata: outIata || null,
      });
    } else {
      // One-way transfer or dropoff is not an airport: no prefilled
      // outbound airport. Clear it to avoid stale state from a previous
      // round-trip.
      this.selectedAirportOut = null;
      this._formFlights.get('airportOut')?.setValue(null);
    }

    if (isRoundTrip) {
      const departureDateSource =
        transferPayload?.dropoffDate ||
        this.formTransports?.firstArrivalDate ||
        transferPayload?.pickupDate;
      const departureTimeSource =
        transferPayload?.transfers?.dropoffTime ||
        transferPayload?.transfers?.return_time ||
        this.formTransports?.firstTime ||
        transfers?.pickupTime;

      const departureDate = this._getTransferDateTime(
        departureDateSource,
        departureTimeSource
      );
      if (departureDate) {
        this._patchDateTime('departureDateOut', 'departureHourOut', departureDate);
      }
    }
  }

  /**
   * Patches a date/hour control pair from a Date object. Centralizes the
   * `new Date(dateValue)` wrap + `_extractHourMinute` extraction that
   * would otherwise be repeated at every prefill site.
   */
  private _patchDateTime(
    dateControlName: 'arrivalDateIn' | 'departureDateOut',
    hourControlName: 'arrivalHourIn' | 'departureHourOut',
    dateValue: Date
  ): void {
    this._formFlights.patchValue({
      [dateControlName]: new Date(dateValue),
[hourControlName]: this._extractHourMinute(dateValue.toString()),
    });
  }

  /**
 * Parsea un string de fecha-hora en formato ISO a objeto Date local
 *
 * Este método utility convierte strings en formato ISO 8601 (YYYY-MM-DDTHH:mm:ssZ)
 * a objetos Date, manejando correctamente la zona horaria local.
 *
 * @param {string} dateTimeStr - String de fecha-hora en formato ISO
 * @returns {Date} - Objeto Date correspondiente o undefined si el string es inválido
 *
 * @parsing
 * 1. Divide en parte de fecha y parte de tiempo
 * 2. Remueve 'Z' (UTC) y milisegundos si están presentes
 * 3. Convierte cada componente a números
 * 4. Crea nuevo Date con componentes específicos
 *
 * @example
 * // Retorna: Date object para 2023-12-25 15:30:00 en zona local
 * this.parseLocalDateTime('2023-12-25T15:30:00Z');
 *
 * @note
 * - Meses se ajustan (-1) porque JavaScript months son 0-based
 * - Maneja strings con o sin milisegundos
 * - Ignora información de zona horaria, trata como hora local
 */
private parseLocalDateTime(dateTimeStr: string): Date {
  if(!dateTimeStr) {
    return;
  }
  const [datePart, timePartRaw] = dateTimeStr.split('T');
  if (!datePart || !timePartRaw) return null;

  const [year, month, day] = datePart.split('-').map(Number);

  const timePart = timePartRaw.replace('Z', '').split('.')[0]; // elimina "Z" y milisegundos
  const [hour, minute, second] = timePart.split(':').map(Number);

  // Parse as UTC so the browser does not shift the day based on its local timezone.
  return new Date(Date.UTC(year, month - 1, day, hour, minute, second));
}

/**
 * Extrae la hora y minutos de un objeto Date en formato HH:mm:00
 *
 * Este método utility formatea la parte de tiempo de un objeto Date
 * a string en formato de 24 horas con segundos establecidos a '00'.
 *
 * @param {string} dateTime - String representando una fecha/hora
 * @returns {string} - Hora formateada como "HH:mm:00"
 *
 * @format
 * - Horas: 2 dígitos con leading zeros
 * - Minutos: 2 dígitos con leading zeros
 * - Segundos: siempre "00"
 *
 * @example
 * // Retorna: "15:30:00"
 * this._extractHourMinute('2023-12-25T15:30:45Z');
 *
 * @uses
 * - getHours(): Obtiene horas (0-23)
 * - getMinutes(): Obtiene minutos (0-59)
 * - padStart(2, '0'): Asegura 2 dígitos
 */
  private _getTransferDateTime(dateValue: any, timeValue: string): Date | null {
    if (!dateValue) return null;

    let date: Date;
    if (typeof dateValue === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(dateValue)) {
      // Bare 'YYYY-MM-DD' must be parsed as local midnight, not UTC midnight.
      // Otherwise `new Date('2026-08-15')` is 2026-08-15T00:00:00Z, and the
      // subsequent `setHours(...)` shifts it back one day in negative-offset
      // zones (UTC-3 Argentina, UTC-4 Bolivia, etc.). Splitting and using
      // the `new Date(y, m, d, ...)` constructor pins it to local time.
      const [y, m, d] = dateValue.split('-').map(Number);
      date = new Date(y, m - 1, d, 0, 0, 0, 0);
    } else {
      // Full ISO timestamp or other Date-parseable input.
      date = new Date(dateValue);
    }
    if (Number.isNaN(date.getTime())) return null;

    const [hours, minutes] = (timeValue || '00:00').split(':').map(Number);
    date.setHours(hours || 0, minutes || 0, 0, 0);
    return date;
  }

  private _extractHourMinute(dateTime: string): string {
    const date = new Date(dateTime);
    // Use UTC accessors because parseLocalDateTime() builds the Date with
    // Date.UTC(...). Reading getHours()/getMinutes() instead would convert
    // to the browser's local time and shift the displayed hour by the
    // timezone offset (e.g., a stored 08:00 UTC reads as 05:00 in
    // Argentina UTC-3, or 06:00 in Bolivia UTC-4 with DST variations).
    const hours = date.getUTCHours().toString().padStart(2, '0');
    const minutes = date.getUTCMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  }

  /**
   * Centralized enable/disable sync for hour controls.
   * Called both on initial form build and on valueChanges.
   * Reads `onlyIn/onlyOut` + form values to decide what to enable.
   */
  private _syncHourControls(): void {
    const arrivalDateIn = this._formFlights.get('arrivalDateIn')?.value;
    const hourDateIn = this._formFlights.get('arrivalHourIn')?.value;
    let departureDateOut = this._formFlights.get('departureDateOut')?.value;
    const departureHourOut = this._formFlights.get('departureHourOut')?.value;

    // [SDD-DIAG] Inspect raw form control state for the four lockable fields.
    // Throttled to once per ~250ms to avoid console spam during valueChanges.
    const now = Date.now();
    if (!this._lastDiagAt || now - this._lastDiagAt > 250) {
      this._lastDiagAt = now;
      const airportInFC = this._formFlights.get('airportIn');
      const airportOutFC = this._formFlights.get('airportOut');
    }

    // Hours stay editable so the user can adjust them ±12h relative to the
    // surrounding transport. Only the dates and the airports are locked
    // once they are filled.

    // Lock the date controls once they match the initial prefill, so the
    // bsDatepicker dropdown cannot be re-opened on untouched fields.
    // _clearDate() re-enables them when the X is clicked.
    const arrivalDateInLocked = this.isDateLocked('arrivalDateIn');
    this._formFlights
      .get('arrivalDateIn')
      ?.[arrivalDateInLocked ? 'disable' : 'enable']({ emitEvent: false });
    const departureDateOutLocked = this.isDateLocked('departureDateOut');
    this._formFlights
      .get('departureDateOut')
      ?.[departureDateOutLocked ? 'disable' : 'enable']({ emitEvent: false });

    // Lock airports once they have a value, so ngui-auto-complete cannot be
    // re-opened. deleteSelectedOption() re-enables them.
    if (this.isAirportLocked('airportIn')) {
      this._formFlights.get('airportIn')?.disable({ emitEvent: false });
    } else {
      this._formFlights.get('airportIn')?.enable({ emitEvent: false });
    }
    if (this.isAirportLocked('airportOut')) {
      this._formFlights.get('airportOut')?.disable({ emitEvent: false });
    } else {
      this._formFlights.get('airportOut')?.enable({ emitEvent: false });
    }

    // Auto-clamp departureDateOut when it falls before arrivalDateIn.
    // bsDatepicker's [minDate] only constrains the picker UI; the underlying
    // FormControl is NOT updated. Without this clamp, the picker can visually
    // show a different date while the form stays invalid until the user types
    // manually, triggering the "Faltan datos obligatorios por completar" gate.
    if (arrivalDateIn && departureDateOut && this.onlyOut) {
      const arrival = new Date(arrivalDateIn);
      const departure = new Date(departureDateOut);
      arrival.setHours(0, 0, 0, 0);
      departure.setHours(0, 0, 0, 0);
      if (departure.getTime() < arrival.getTime()) {
        const clamped = new Date(arrival);
        this._formFlights
          .get('departureDateOut')
          ?.setValue(clamped, { emitEvent: true });
        this._formFlights
          .get('departureDateOut')
          ?.markAsTouched();
        this._formFlights
          .get('departureDateOut')
          ?.updateValueAndValidity();
        departureDateOut = clamped;
      }
    }

    // The DOM-level attribute sync is handled by ngAfterViewChecked (with a
    // throttle) because ngui-auto-complete mounts its internal <input>s
    // asynchronously after the first render cycle.

    // In-leg: arrivalDateIn → arrivalHourIn + departureDateOut
    if (arrivalDateIn) {
      this.minDateArrivalOut = new Date(arrivalDateIn);
      if (this.onlyIn) {
        this._formFlights.get('arrivalHourIn')?.enable({ emitEvent: false });
      }
      if (this.onlyOut) {
        this._formFlights.get('departureDateOut')?.enable({ emitEvent: false });
      }
    } else {
      this._formFlights.get('arrivalHourIn')?.disable({ emitEvent: false });
      this._formFlights.get('departureDateOut')?.disable({ emitEvent: false });
    }

    // Cross-leg: arrivalHourIn → departureHourOut
    if (arrivalDateIn && hourDateIn && this.onlyOut) {
      this._formFlights.get('departureHourOut')?.enable({ emitEvent: false });
    } else if (!arrivalDateIn || !hourDateIn) {
      this._formFlights.get('departureHourOut')?.disable({ emitEvent: false });
    }

    // Out-leg: departureDateOut → arrivalDateOut
    if (departureDateOut && this.onlyOut) {
      this._formFlights.get('arrivalDateOut')?.enable({ emitEvent: false });
    } else {
      this._formFlights.get('arrivalDateOut')?.disable({ emitEvent: false });
    }

    // Out-leg: arrivalDateOut → arrivalHourOut
    if (departureDateOut && departureHourOut && this.onlyOut) {
      this._formFlights.get('arrivalHourOut')?.enable({ emitEvent: false });
    } else if (!departureDateOut || !departureHourOut) {
      this._formFlights.get('arrivalHourOut')?.disable({ emitEvent: false });
    }
  }

  /** Tears down prior date subscriptions and re-wires them. */
  private _rewireDateListeners(): void {
    this._formRebuild$.next();
    this.subscribeFormCheckDatesIn();
    this.subscribeFormCheckDatesOut();
  }

  /** Template-accessible wrapper for the round-trip-airport-both detector. */
  _isRoundTripAirportBothEnds(): boolean {
    return this._hasRoundTripAirportBothEnds();
  }

  /** Detects round-trip transfer with airport at both pickup and dropoff. */
  private _hasRoundTripAirportBothEnds(): boolean {
    const items = this._actualItinerary?.items;
    if (!Array.isArray(items) || items.length === 0) {
      return false;
    }

    const transportItems = items.filter((it: any) => it?.category_id === 8);
    if (transportItems.length === 0) {
      return false;
    }

    let hasAirportPickup = false;
    let hasAirportDropoff = false;

    for (const item of transportItems) {
      const payload = Array.isArray(item?.payload) ? item.payload[0] : item?.payload;
      const transfers = payload?.transfers;
      if (!transfers) continue;

      const pickupType = transfers?.pickupLocation?.type;
      const dropoffType = transfers?.dropoffLocation?.type;
      if (pickupType === 'airport') hasAirportPickup = true;
      if (dropoffType === 'airport') hasAirportDropoff = true;
    }

    return hasAirportPickup && hasAirportDropoff;
  }

  /**
   * Shows or hides a leg. When hiding, clears the leg's controls and resets
   * the corresponding selectedAirport/selectedAirline mirrors.
   */
   setLegVisible(side: 'in' | 'out', visible: boolean): void {
    if (side === 'out') {
      this.onlyOut = visible;
      this.legUnlocked = visible;
      if (!visible) {
        this.clearLeg('out');
      }
    } else {
      this.onlyIn = visible;
      this.legUnlocked = visible;
      if (!visible) {
        this.clearLeg('in');
      }
    }
  }

  /**
   * Clears all controls for the given leg and resets the selectedAirport/
   * selectedAirline mirrors.
   */
  private clearLeg(side: 'in' | 'out'): void {
    if (side === 'out') {
      this._formFlights.patchValue({
        airlineOut: null, _flightNumberOut: null, flightNumberOut: null,
        departureDateOut: null, departureHourOut: null, airportOut: null,
      }, { emitEvent: false });
      this.selectedAirlineOut = undefined;
      this.selectedAirlineOutName = '';
      this.selectedAirportOut = '';
    } else {
      this._formFlights.patchValue({
        airlineIn: null, _flightNumberIn: null, flightNumberIn: null,
        arrivalDateIn: null, arrivalHourIn: null, airportIn: null,
      }, { emitEvent: false });
      this.selectedAirlineIn = undefined;
      this.selectedAirlineInName = '';
      this.selectedAirportIn = '';
    }
  }

  // Delegates for backward-compatible template call sites. The "add" variants
  // also mark the newly-revealed leg's required controls as touched so the
  // "campo requerido" messages show up immediately, without waiting for the
  // user to click Aceptar.
  addMissingLeg(): void {
    this.setLegVisible('out', true);
    this._touchRequiredControls(['airlineOut', 'departureDateOut', 'departureHourOut', 'airportOut', 'flightNumberOut']);
  }
  addMissingArrivalLeg(): void {
    this.setLegVisible('in', true);
    this._touchRequiredControls(['airlineIn', 'arrivalDateIn', 'arrivalHourIn', 'airportIn', 'flightNumberIn']);
  }
  removeMissingLeg(): void { this.setLegVisible('out', false); }
  removeMissingArrivalLeg(): void { this.setLegVisible('in', false); }

  private _touchRequiredControls(controlNames: string[]): void {
    if (!this._formFlights) return;
    for (const name of controlNames) {
      const control = this._formFlights.get(name);
      if (control && !control.touched) {
        control.markAsTouched();
      }
    }
  }

  /**
 * Suscribe y gestiona las validaciones y habilitación condicional de campos de fecha/hora para vuelos de entrada
 *
 * @sideEffects
 * - Actualiza minDateArrivalOut para validaciones cruzadas
 * - Ejecuta validateArrivalHourIn()
 */
  subscribeFormCheckDatesIn(): void {
    const debounceConfig = (time: number = 750) =>
      pipe(debounceTime(time), distinctUntilChanged());

    this._formFlights.get('arrivalDateIn')?.valueChanges
      .pipe(debounceConfig(), takeUntil(this._formRebuild$), takeUntil(this.destroy$))
      .subscribe(() => {
        this._syncHourControls();
      });

    this._formFlights.get('arrivalHourIn')?.valueChanges
      .pipe(debounceConfig(), takeUntil(this._formRebuild$), takeUntil(this.destroy$))
      .subscribe(() => {
        this._syncHourControls();
        this.validateArrivalHourIn();
      });
  }


/**
 * Valida que la hora de llegada sea coherente con la hora actual del sistema
 * y con la hora de salida cuando aplica
 *
 * @validation
 * - arrivalHourIn no puede ser menor a la hora actual del sistema
 * - Cuando departureDateIn y arrivalDateIn son el mismo día:
 * - Si arrivalHourIn es anterior, se corrige automáticamente
 *
 * @actions
 * 1. Valida contra hora actual del sistema
 * 3. Corrige valores inválidos automáticamente
 * 4. Muestra toast de advertencia al usuario
 */
validateArrivalHourIn(): void {
  const arrivalDate = this._formFlights.get('arrivalDateIn')?.value;
  const arrivalHour = this._formFlights.get('arrivalHourIn')?.value;

  if (arrivalDate && arrivalHour) {
    try {
      // Manejar tanto string como objeto Date
      const dateObj = new Date(arrivalDate);
      const dateString = moment(dateObj).format('YYYY-MM-DD');

      const currentMoment = moment();
      const arrivalMoment = moment(`${dateString} ${arrivalHour}`, 'YYYY-MM-DD HH:mm');

      if (!arrivalMoment.isValid()) {
        console.error('Fecha/hora inválida:', dateString, arrivalHour);
        return;
      }

      if (arrivalMoment.isBefore(currentMoment)) {
        const correctedTime = currentMoment.clone().add(1, 'minutes');
        const formatted = correctedTime.format('HH:mm');
        this._formFlights.get('arrivalHourIn')?.setValue(formatted, { emitEvent: false });
        this.notificationService.warning('El horario de llegada no puede ser menor a la hora actual.');
      }
    } catch (error) {
      console.error('Error en validación de hora:', error);
    }
  }
}


/**
 * Formatea un objeto Date a string en formato HH:mm con 2 dígitos
 *
 * Este método utility convierte la parte horaria de un objeto Date
 * a un string formateado con horas y minutos de 2 dígitos cada uno.
 *
 * @param {Date} date - Objeto Date a formatear
 * @returns {string} - Hora formateada como "HH:mm" (ej: "09:05", "14:30")
 *
 * @format
 * - Horas: 2 dígitos con leading zero (00-23)
 * - Minutos: 2 dígitos con leading zero (00-59)
 *
 * @uses
 * - getHours(): Obtiene horas del Date (0-23)
 * - getMinutes(): Obtiene minutos del Date (0-59)
 * - padStart(2, '0'): Asegura 2 dígitos con leading zeros
 *
 * @example
 * // Retorna: "09:05"
 * this.formatTime(new Date(2023, 11, 25, 9, 5));
 *
 * @example
 * // Retorna: "14:30"
 * this.formatTime(new Date(2023, 11, 25, 14, 30));
 */
  formatTime(date: Date): string {
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${hours}:${minutes}`;
  }

  /**
 * Suscribe y gestiona las validaciones y habilitación condicional de campos de fecha/hora para vuelos de salida
 *
 * @sideEffects
 * - Ejecuta validateDepartureHourOut() para validaciones
 */
  subscribeFormCheckDatesOut(): void {
    const debounceConfig = (time: number = 750) =>
      pipe(debounceTime(time), distinctUntilChanged());

    this._formFlights.get('departureDateOut')?.valueChanges
      .pipe(debounceConfig(), takeUntil(this._formRebuild$), takeUntil(this.destroy$))
      .subscribe(() => {
        this._syncHourControls();
      });

    this._formFlights.get('departureHourOut')?.valueChanges
      .pipe(debounceConfig(), takeUntil(this._formRebuild$), takeUntil(this.destroy$))
      .subscribe(() => {
        this._syncHourControls();
        this.validateDepartureHourOut();
      });
  }

/**
 * Calcula y establece la hora mínima permitida para la llegada de vuelos de salida
 *
 * Este métod
/**
 * Valida que la hora de llegada de salida sea coherente con la hora de salida
 *
 * Este método compara las horas de salida y llegada para vuelos de salida cuando
 * ocurren en el mismo día y asegura que la hora de llegada no sea anterior a la
 * hora de salida, corrigiendo automáticamente y notificando al usuario.
 *
 * @validation
 * - Solo aplica cuando departureDateOut y arrivalDateOut son el mismo día
 * - arrivalHourOut debe ser posterior a departureHourOut
 * - Si es anterior, se corrige a departureHourOut + 1 minuto
 *
 * @actions
 * 1. Compara fechas usando moment.js para consistencia
 * 2. Si arrivalHourOut es anterior, calcula corrección
 * 3. Setea valor corregido en el formulario
 * 4. Muestra advertencia al usuario via notificationService
 *
 * @uses moment.js - Para parsing y comparación precisa
 * @uses notificationService.warning() - Para notificación de usuario
 *
 * @example
 * // Si departureHourOut = "16:45" y arrivalHourOut = "16:40"
 * // Se corrige a "16:46" y muestra advertencia
 */
validateDepartureHourOut(): void {
  const arrivalDate = this._formFlights.get('arrivalDateIn')?.value;
  const arrivalHour = this._formFlights.get('arrivalHourIn')?.value;
  const departureDate = this._formFlights.get('departureDateOut')?.value;
  const departureHour = this._formFlights.get('departureHourOut')?.value;

  if (arrivalDate && arrivalHour && departureDate && departureHour) {
    try {
      // Convertir fechas a formato YYYY-MM-DD
      const arrivalDateObj = new Date(arrivalDate);
      const arrivalDateString = moment(arrivalDateObj).format('YYYY-MM-DD');

      const departureDateObj = new Date(departureDate);
      const departureDateString = moment(departureDateObj).format('YYYY-MM-DD');

      // Crear momentos para comparación
      const arrivalMoment = moment(`${arrivalDateString} ${arrivalHour}`, 'YYYY-MM-DD HH:mm');
      const departureMoment = moment(`${departureDateString} ${departureHour}`, 'YYYY-MM-DD HH:mm');

      if (!arrivalMoment.isValid() || !departureMoment.isValid()) {
        console.error('Fechas/horas inválidas:', arrivalDateString, arrivalHour, departureDateString, departureHour);
        return;
      }

      // Solo comparar si las fechas son iguales
      if (arrivalDateString === departureDateString) {
        if (departureMoment.isBefore(arrivalMoment)) {
          const correctedTime = arrivalMoment.clone().add(1, 'minutes');
          const formatted = correctedTime.format('HH:mm');
          this._formFlights.get('departureHourOut')?.setValue(formatted, { emitEvent: false });
          this.notificationService.warning('El horario de salida no puede ser menor al horario de llegada.');
        }
      }
    } catch (error) {
      console.error('Error en validación de hora de salida:', error);
    }
  }
}

/**
 * Alterna el modo de visualización de hora entre formato 12h y 24h
 *
 * Este método cambia el estado de `ismeridian` que controla si los selectores de hora
 * deben mostrar formato meridiano (AM/PM) o formato 24 horas.
 *
 * @returns {void}
 *
 * @state
 * - ismeridian = true → Formato 12h con AM/PM
 * - ismeridian = false → Formato 24h militar
 *
 * @example
 * // Alternar de 24h a 12h:
 * this.toggleMode(); // ismeridian cambia de false a true
 *
 * @usage
 * Normalmente usado en conjunction con componentes de selección de hora
 */
  toggleMode(): void {
    this.ismeridian = !this.ismeridian;
  }

  /**
 * Cierra el modal actual ocultándolo de la vista
 *
 * Este método proporciona una forma de cerrar el modal activo mediante
 * la referencia almacenada en `modalRef`.
 *
 * @returns {void}
 *
 * @uses modalRef.hide() - Método de Bootstrap para ocultar modales
 *
 * @example
 * // Cerrar modal desde template:
 * <button (click)="cancel()">Cancelar</button>
 */
  cancel() {
    this.modalRef.hide();
  }

/**
 * Trunca una cadena a 18 caracteres si excede la longitud máxima
 *
 * Este método utility previene visualizaciones muy largas recortando
 * strings que superan los 18 caracteres, agregando "..." implícitamente.
 *
 * @param {string} str - Cadena a truncar
 * @returns {string} - Cadena original o truncada a 18 caracteres
 *
 * @limit
 * - Máximo 18 caracteres
 * - No agrega ellipsis (...) explícitamente
 *
 * @example
 * // Retorna: "Este es un texto mu"
 * this.subStrings("Este es un texto muy largo");
 *
 * @example
 * // Retorna: "Texto corto"
 * this.subStrings("Texto corto");
 */
  subStrings(str){
    if(str.length>18){
      return str.slice(0,18)
    }else{
      return str
    }
  }
/**
 * Convierte una cadena a formato de título (Title Case)
 *
 * Este método convierte todo el texto a minúsculas y luego capitaliza
 * la primera letra de cada palabra, implementando formato de título proper.
 *
 * @param {string} str - Cadena a convertir
 * @returns {string} - Cadena en Title Case
 *
 * @transformation
 * 1. Convierte toda la cadena a minúsculas
 * 2. Capitaliza la primera letra de cada palabra
 *
 * @uses regex /\b\w/g - Encuentra el primer caracter de cada palabra
 *
 * @example
 * // Retorna: "Juan Pérez García"
 * this.stingUpperCase("juan pérez garcía");
 *
 * @example
 * // Retorna: "New York City"
 * this.stingUpperCase("NEW YORK CITY");
 */
  stingUpperCase(str){
    let e = str.toLowerCase()
    return e.replace(/\b\w/g, l => l.toUpperCase())
  }

  /**
 * Elimina la opción seleccionada de un campo específico y limpia propiedades relacionadas
 *
 * Este método proporciona una forma centralizada de resetear campos del formulario
 * y sus propiedades asociadas según el tipo de campo especificado.
 *
 * @param {string} type - Tipo de campo a limpiar
 * @returns {void}
 *
 * @supportedTypes
 * - 'airportIn': Aeropuerto de entrada
 * - 'airlineIn': Aerolínea de entrada
 * - 'airportOut': Aeropuerto de salida
 * - 'airlineOut': Aerolínea de salida
 * - 'cityDepartureIn': Ciudad de salida
 * - 'iataCityArrivalOut': Ciudad de llegada IATA
 *
 * @actions
 * - Resetea el valor del control del formulario
 * - Limpia propiedades del componente relacionadas
 * - Maneja casos especiales para transfers con categoría 8
 *
 * @specialCase
 * Para 'airportOut' con transfers específicos, también limpia propiedades de aeropuerto de entrada
 */
  deleteSelectedOption(type: string): void {

    switch(type) {
      case 'airportIn':
        this._formFlights.get('airportIn')?.setValue('');
        this.selectedAirportIn = '';
        this.selectedAirportInId = undefined;
        this.selectedAirportInCountryCode = undefined;
        break;
      case 'airlineIn':
        this._formFlights.get('airlineIn')?.setValue(null);
        this._formFlights.get('_flightNumberIn')?.setValue(null);
        this.selectedAirlineIn = '';
        this.valueAirlineCodeIata = undefined;
        this.selectedAirlineInName = '';
        break;
      case 'airportOut':
        this._formFlights.get('airportOut')?.setValue('');
            if(this.payloadSearch && this.payloadSearch[0].categoriesId[0] === 8 &&
            this.payloadSearch[0].transfers.pickupLocation.type !== 'airport' &&
            this.payloadSearch[0].transfers.dropoffLocation.type === 'airport') {
                  this.selectedAirportInId = undefined;
              this.selectedAirportInCountryCode = undefined;
          }
        this.selectedAirportOut = '';
        break;
      case 'airlineOut':
          this._formFlights.get('airlineOut')?.setValue(null);
          this._formFlights.get('_flightNumberOut')?.setValue(null);
          this.selectedAirlineOut = undefined;
          this.selectedAirlineOutName = '';
        break;
      default:
        break;
    }
  }

  /**
   * Clears a date form control (and resets its touched state).
   * No-op when the control is locked (isDateLocked returns true): if the
   * form was opened with a prefill, the value is immutable for this
   * session and the X is hidden in the template — this guard is a
   * defense-in-depth check so any programmatic caller also fails safely.
   * Does NOT clear the related time field — the time will be visually
   * disabled because the input is bound to disabled state based on the
   * date being present.
   * @param controlName 'arrivalDateIn' or 'departureDateOut'
   */
  _clearDate(controlName: 'arrivalDateIn' | 'departureDateOut'): void {
    if (this.isDateLocked(controlName)) {
      return;
    }
    const fc = this._formFlights.get(controlName);
    if (fc) {
      // The date controls may be disabled by isDateLocked() once a value
      // is set; setValue() alone would not re-enable the picker. Enable
      // first, then clear, mirroring deleteSelectedOption() for airports.
      fc.enable({ emitEvent: false });
      fc.setValue(null);
      fc.markAsUntouched();
    }
    // Close any open time picker for safety
    this.activeTimePicker = null;
  }

  /**
   * True when the airport control already has a value. Used by the template
   * to disable the ngui-auto-complete input (the [attr.readonly] alone is
   * ignored by ngui-auto-complete). The X button (handled by
   * deleteSelectedOption) re-enables it.
   */
  // Snapshot of the airport values captured when the form is opened. Used by
  // isAirportLocked() to decide whether the readonly branch should render:
  // if the current value still matches the initial value, the user has not
  // touched the field, so the readonly surface is appropriate. Once the user
  // types or selects a new option, the readonly branch is replaced by the
  // autocomplete.
  private _initialAirportValues: {
    airportIn?: any;
    airportOut?: any;
  } = {};

  /** Capture the current airport values as the "initial" snapshot. */
  captureInitialAirportValues(): void {
    const inCtrl = this._formFlights?.get('airportIn');
    const outCtrl = this._formFlights?.get('airportOut');
    this._initialAirportValues = {
      airportIn: inCtrl?.value ? JSON.parse(JSON.stringify(inCtrl.value)) : null,
      airportOut: outCtrl?.value ? JSON.parse(JSON.stringify(outCtrl.value)) : null,
    };
  }

  // Snapshot of the date values captured when the form is opened. Used by
  // isDateLocked() to decide whether the readonly branch should render:
  // if the form was opened with a prefill for this field, the value is
  // immutable for the rest of the session — no editing, no clearing. The
  // bsDatepicker stays clickable so the user can browse, but the X is
  // hidden and _clearDate() is not exposed.
  private _initialDateValues: {
    arrivalDateIn?: number | null;
    departureDateOut?: number | null;
  } = {};

  /** Capture the current date values as the "initial" snapshot. */
  captureInitialDateValues(): void {
    const inCtrl = this._formFlights?.get('arrivalDateIn');
    const outCtrl = this._formFlights?.get('departureDateOut');
    this._initialDateValues = {
      arrivalDateIn: inCtrl?.value ? new Date(inCtrl.value).getTime() : null,
      departureDateOut: outCtrl?.value ? new Date(outCtrl.value).getTime() : null,
    };
  }

  /**
   * True when the date control is locked and should render as readonly.
   *
   * Lock applies in exactly two cases:
   * - hasReservedItem: the booking is reserved, all flight fields are read-only.
   * - The form was opened with a prefill (`_initialDateValues[dateControl] != null`)
   *   AND the current FormControl still holds a value: the prefill is
   *   immutable for the rest of the session and the user cannot edit,
   *   replace, or clear it via this modal.
   *
   * Once the user clears the date (via the X or by removing the leg),
   * the FormControl goes back to null. We drop the lock at that point:
   * there's nothing left to protect, and re-adding the leg should give
   * the user an empty editable field, not a ghost of the deleted prefill.
   *
   * If neither case applies, the field is freely editable regardless of
   * the `component` context.
   */
  isDateLocked(dateControl: 'arrivalDateIn' | 'departureDateOut'): boolean {
    if (this.hasReservedItem) {
      return true;
    }
    if (this._initialDateValues[dateControl] != null) {
      const fc = this._formFlights?.get(dateControl);
      if (!fc?.value) {
        return false;
      }
      return true;
    }
    return false;
  }

  isAirportLocked(airportControl: 'airportIn' | 'airportOut'): boolean {
    if (this.hasReservedItem || this.component === 'fly') {
      return true;
    }
    const fc = this._formFlights?.get(airportControl);
    if (!fc?.value) {
      return false;
    }
    const initial = this._initialAirportValues[airportControl];
    const current = fc.value;
    if (typeof current === 'object') {
      const currentKey = current?.name && current?.iata
        ? `${current.name}::${current.iata}`
        : JSON.stringify(current);
      const initialKey = initial && typeof initial === 'object'
        ? `${initial?.name ?? ''}::${initial?.iata ?? ''}`
        : String(initial);
      return currentKey === initialKey;
    }
    return false;
  }

  /**
   * Force the DOM <input> elements to reflect the locked state.
   *
   * Two third-party wrappers ignore Angular FormControl changes:
   *   - ngui-auto-complete 3.x never reads `disabled` from the FormControl
   *     nor from a [disabled] attribute on its directive host. It just
   *     re-renders its own internal <input> editable.
   *   - bsDatepicker (ngx-bootstrap 7.x) reads `isDisabled` from `bsConfig`
   *     at component init only; runtime changes do not propagate to the
   *     picker <input>.
   *
   * As a last resort, after every form state change we walk each known
   * input by id and toggle the native `disabled` attribute ourselves. The
   * _X button handlers rely on the FormControl state to clean up, so this
   * DOM patch is safe.
   */
  private _syncLockedInputsToDom(): void {
    const doc = typeof document !== 'undefined' ? document : null;
    if (!doc) {
      return;
    }

    const applyOne = (
      inputId: string,
      locked: boolean,
      isDate = false,
      displayInputId?: string
    ) => {
      const el = (doc.getElementById(inputId) ||
        (displayInputId ? doc.getElementById(displayInputId) : null)) as
        | HTMLInputElement
        | null;
      if (!el) {
        return;
      }
      const wants = locked;
      const isCurrently = el.disabled === true;
      if (wants !== isCurrently) {
        el.disabled = wants;
      }
      el.style.pointerEvents = wants ? 'none' : '';
      el.style.backgroundColor = wants ? '#efefef' : '';
      // Tab navigation: skip locked fields.
      if (wants) {
        el.setAttribute('tabindex', '-1');
        el.setAttribute('aria-disabled', 'true');
      } else {
        el.removeAttribute('tabindex');
        el.removeAttribute('aria-disabled');
      }
    };

    const applyAutoCompleteOne = (inputName: string, locked: boolean) => {
      const projected = doc.querySelector(
        `input[formcontrolname="${inputName}"]`
      ) as HTMLInputElement | null;
      const wrapper = projected?.closest(
        'ngui-auto-complete, .ngui-auto-complete'
      ) as HTMLElement | null;
      if (!wrapper) {
        return;
      }

      const alreadyLocked =
        wrapper.dataset.lockedByUs === inputName + ':1';
      if (locked && !alreadyLocked) {
        wrapper.dataset.lockedByUs = inputName + ':1';
        const swallow = (evt: Event) => {
          evt.preventDefault();
          evt.stopImmediatePropagation();
          evt.stopPropagation();
        };
        wrapper.addEventListener('keydown', swallow, { capture: true });
        wrapper.addEventListener('keypress', swallow, { capture: true });
        wrapper.addEventListener('beforeinput', swallow, { capture: true });
        wrapper.addEventListener('input', swallow, { capture: true });
        wrapper.addEventListener('click', swallow, { capture: true });
        wrapper.addEventListener('mousedown', swallow, { capture: true });
      } else if (!locked && alreadyLocked) {
        wrapper.dataset.lockedByUs = '0';
      }

      // Apply the visual lock to whatever inputs are mounted right now.
      const inputs = Array.from(
        wrapper.querySelectorAll<HTMLInputElement>('input')
      );
      inputs.forEach((el) => {
        try {
          el.disabled = locked;
        } catch {
          // ignore
        }
        el.style.backgroundColor = locked ? '#efefef' : '';
        if (locked) {
          el.setAttribute('aria-disabled', 'true');
        } else {
          el.removeAttribute('aria-disabled');
        }
      });
      wrapper.style.opacity = locked ? '0.7' : '';
    };

    const arrivalDateLocked = this.isDateLocked('arrivalDateIn');
    const departureDateLocked = this.isDateLocked('departureDateOut');
    const airportInLocked = this.isAirportLocked('airportIn');
    const airportOutLocked = this.isAirportLocked('airportOut');

    applyOne('arrivalDateIn', arrivalDateLocked, true, 'arrivalDateIn-display');
    applyOne('departureDateOut', departureDateLocked, true, 'departureDateOut-display');
    applyAutoCompleteOne('airportIn', airportInLocked);
    applyAutoCompleteOne('airportOut', airportOutLocked);
  }

  /**
   * Angular lifecycle hook that fires after every change-detection cycle.
   * The third-party wrappers (ngui-auto-complete, bsDatepicker) finish
   * rendering their internal <input>s asynchronously with respect to the
   * first _syncHourControls() call. Re-applying the lock here ensures the
   * DOM attributes catch up once the wrappers exist.
   *
   * Throttled to once every 100ms because ngAfterViewChecked is called
   * many times per second; the DOM state we sync is cheap but we still
   * avoid running it on every keystroke.
   */
  ngAfterViewChecked(): void {
    if (!this._formFlights) {
      return;
    }
    const now = Date.now();
    if (this._lastDomSyncAt && now - this._lastDomSyncAt < 100) {
      return;
    }
    this._lastDomSyncAt = now;
    this._syncLockedInputsToDom();
  }

  /**
 * Extrae la hora de un string de fecha-hora en formato ISO
 *
 * Este método utility extrae la parte horaria (HH:MM) de un string
 * en formato ISO 8601 mediante slicing de posiciones fijas.
 *
 * @param {string} dateTime - String de fecha-hora en formato ISO (YYYY-MM-DDTHH:MM:SS)
 * @returns {string} - Hora en formato "HH:MM" o string vacío si no hay fecha
 *
 * @formatAssumption
 * - Asume formato ISO: "YYYY-MM-DDTHH:MM:SS"
 * - Extrae caracteres 11-16: "HH:MM"
 *
 * @example
 * // Retorna: "14:30"
 * this.getHourFly("2023-12-25T14:30:45Z");
 *
 * @example
 * // Retorna: ""
 * this.getHourFly(null);
 */
  getHourFly(dateTime: any): string {
      if (dateTime) {
        return dateTime.slice(11, 16); // 'HH:MM' empieza en el índice 11
      }
      return '';
   }

   /**
 * Calcula y formatea la diferencia de tiempo entre dos fechas de vuelo
 *
 * Este método calcula la diferencia entre la fecha de llegada de un vuelo de entrada
 * y la fecha de salida de un vuelo de salida, formateando el resultado para display.
 *
 * @param {string} dateFlyIn - Fecha de llegada del vuelo de entrada (ISO string)
 * @param {string} dateFlyOut - Fecha de salida del vuelo de salida (ISO string)
 * @returns {string} - Diferencia formateada como "(+X días)" o "(+HH:MM hs.)"
 *
 * @format
 * - Diferencia > 24 horas: "(+X día[s])"
 * - Diferencia < 24 horas: "(+HH:MM hs.)"
 *
 * @calculation
 * - Convierte strings a objetos Date
 * - Calcula diferencia en milisegundos
 * - Convierte a días, horas y minutos
 *
 * @example
 * // Retorna: "(+2 días)"
 * this.afterDateFlyOut("2023-12-25T14:30:00Z", "2023-12-27T10:00:00Z");
 *
 * @example
 * // Retorna: "(+03:45 hs.)"
 * this.afterDateFlyOut("2023-12-25T14:30:00Z", "2023-12-25T18:15:00Z");
 */
   afterDateFlyOut(dateFlyIn: string, dateFlyOut: string): string {
    const inDate = new Date(dateFlyIn);
    const outDate = new Date(dateFlyOut);

    // Diferencia en milisegundos
    const diffTime = outDate.getTime() - inDate.getTime();

    // Convertimos la diferencia a días, horas y minutos
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    const diffHours = Math.floor((diffTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const diffMinutes = Math.floor((diffTime % (1000 * 60 * 60)) / (1000 * 60));

    if (diffDays > 0) {
        return `(+${diffDays} día${diffDays > 1 ? 's' : ''})`;
    } else {
        return `(+${diffHours}:${diffMinutes.toString().padStart(2, '0')} hs.)`;
    }
}

/**
 * Controla la visibilidad del tooltip de vuelo y aplica filtros de color cuando se muestra
 *
 * Este método gestiona el estado de visualización del tooltip y cuando se activa (event = true),
 * aplica filtros CSS personalizados a los íconos basados en el color configurado para vuelos.
 *
 * @param {boolean} event - Estado de visibilidad del tooltip (true = visible, false = oculto)
 * @returns {void}
 *
 * @actions
 * - Actualiza el estado de tooltipFlight
 * - Cuando se muestra (event = true), ejecuta applyImageFilter()
 *
 * @sideEffects
 * - Modifica tooltipFlight con el nuevo estado
 * - Ejecuta applyImageFilter() que modifica estilos CSS de íconos
 *
 * @example
 * // Mostrar tooltip y aplicar filtros:
 * this.changeTooltipFlightVisible(true);
 *
 * // Ocultar tooltip:
 * this.changeTooltipFlightVisible(false);
 */
changeTooltipFlightVisible(event: boolean): void {
  if(event) {
     this.applyImageFilter();
  }

  this.tooltipFlight = event;
}

     /**
 * Aplica filtros CSS personalizados a íconos basados en el color de vuelo configurado
 *
 * Este método convierte un color hexadecimal a filtros CSS equivalentes y los aplica
 * a los íconos de vuelo, específicamente al primero y último ícono de la lista.
 *
 * @returns {void}
 *
 * @process
 * 1. Convierte hex color a filtros CSS usando CssFilterConverter
 * 2. Extrae y formatea los filtros de color
 * 3. Aplica los filtros a los íconos con setTimeout para evitar conflictos de renderizado
 *
 * @uses CssFilterConverter.hexToFilter() - Conversor de hex a filtros CSS
 * @uses setTimeout(0) - Para aplicar estilos después del ciclo de renderizado actual
 *
 * @targetElements
 * - Primer ícono (index = 0)
 * - Último ícono (index = icons.length - 1)
 *
 * @styling
 * - filter: Aplica los filtros de color convertidos
 * - width: 40px - Establece ancho fijo para los íconos
 *
 * @dependencies
 * - Requiere this.colorFlight configurado con color hexadecimal
 * - Requiere this.icons con referencias a elementos DOM
 */
    applyImageFilter() {
      const color = this.colorFlight;
      const tempFilterObj = CssFilterConverter.hexToFilter(color, { sheen: false });

      //Extraemos el literal en String de la conversión
      const tempFilterStr = Object.keys(tempFilterObj).map(key => `${key}(${tempFilterObj[key]})`).join(" ");

      // Convierte el color a un objeto de filtro de CSS y extrae los filtros de la respuesta color del resultado.
      const colorRegex = /color\((.*)\)/;
      const colorMatch = tempFilterStr.match(colorRegex);
      const colorFilter = colorMatch ? colorMatch[1] : "";

      const filter = colorFilter;

      // Establece el atributo de estilo "filter" en el elemento de imagen con los filtros de color extraídos.
      setTimeout(() => {

        this.icons.forEach(((icon, index) => {
          if(index === 0 || index === this.icons.length - 1) {
            icon.nativeElement.setAttribute('style', `filter: ${filter}; width: 40px;`);
          }
        }));
      }, 0);
    }

    /**
 * Obtiene los vuelos internos (excluyendo el primero y último) del itinerario actual
 *
 * Este método crea una copia del array de vuelos y retorna un subarray que excluye
 * el primer y último elemento, que típicamente representan los vuelos de inicio y fin.
 *
 * @returns {any[]} - Array con los vuelos internos (excluyendo primer y último)
 *
 * @operation
 * 1. Crea shallow copy del array flights
 * 2. Usa slice(1, -1) para excluir primer y último elemento
 * 3. Retorna el subarray resultante
 *
 * @example
 * // Si flights = [A, B, C, D, E]
 * // Retorna: [B, C, D]
 * this.getFlightsInternal();
 *
 * @note
 * - Usa spread operator para crear copia superficial
 * - No modifica el array original _actualItinerary.flights
 */
    getFlightsInternal(): any {
      const newArrFlights = [...this._actualItinerary.flights];

      return newArrFlights.slice(1, -1);
    }

    /**
 * Crea y inserta un nuevo vuelo interno en el itinerario actual
 *
 * Este método genera un nuevo vuelo usando newFly() y lo inserta en la penúltima
 * posición del array de vuelos, justo antes del último vuelo existente.
 *
 * @returns {void}
 *
 * @process
 * 1. Genera nuevo vuelo con newFly()
 * 2. Calcula posición de inserción (penúltima posición)
 * 3. Inserta el nuevo vuelo usando splice()
 *
 * @position
 * - Inserta en: flights.length - 1 (penúltima posición)
 * - No elimina elementos existentes (splice con deleteCount = 0)
 *
 * @modification
 * - Modifica directamente _actualItinerary.flights
 * - El array original es alterado con el nuevo elemento
 *
 * @uses newFly() - Método factory para crear vuelos nuevos
 * @uses Array.splice() - Para inserción en posición específica
 *
 * @example
 * // Antes: flights = [A, B, C]
 * this.createFlyInternal();
 * // Después: flights = [A, B, newFly, C]
 */
  createFlyInternal(): void {
    const newFly = this.newFly();

    // Crear una NUEVA referencia del array para que ngOnChanges lo detecte
    this.flightsInternal = [...this.flightsInternal, newFly];
  }
  /**
   * Lightweight validity check used by the submit gate so a partial modal
   * can be saved. Returns true when at least one leg (arrival or departure)
   * has its required fields filled.
   *
   * Used by the "Aceptar" button so a transfers-only form can be submitted
   * with just the arrival, just the departure, or both legs filled.
   */
  isPartialLegValid(): boolean {
    const inFilled = !!this._formFlights.get('airlineIn')?.value?.name
      && !!this._formFlights.get('arrivalDateIn')?.value
      && !!this._formFlights.get('arrivalHourIn')?.value;
    const outFilled = !!this._formFlights.get('airlineOut')?.value?.name
      && !!this._formFlights.get('departureDateOut')?.value
      && !!this._formFlights.get('departureHourOut')?.value;
    return inFilled || outFilled;
  }

  /**
   * Swap the arrival and departure legs of the general flight. Exchanges every
   * user-visible field (airline, flight number, date, hour, airport) plus the
   * internal flags that drive the autocomplete labels.
   *
   * Empty legs are swapped too — pressing the button on a half-filled form
   * moves the empty side to where the filled side used to be. That matches
   * the "swap" semantics of the original `swapLocations` in transports.
   *
   * Caveat: `selectedAirportInCountryCode` and `selectedAirportInId` are not
   * swapped because the codebase doesn't track them per-leg — both refer to
   * the arrival airport. After a swap, the payload's `iata_code`/`id_airport`
   * may not match the (new) arrival airport. This mirrors a pre-existing
   * limitation; fixing it cleanly requires re-deriving those fields in
   * `payloadMap` from the new `airportIn` form value.
   */
  swapFlightLegs(): void {
    if (!this._formFlights) return;

    // Toggle the rotation animation so the button gives visual feedback
    // when it has been clicked (vs just hovered).
    this.isRotatedSwap = !this.isRotatedSwap;

    const snapshot = this._formFlights.getRawValue();

    // FormControls
    this._formFlights.patchValue({
      airlineIn: snapshot['airlineOut'] ?? null,
      _flightNumberIn: snapshot['_flightNumberOut'] ?? null,
      flightNumberIn: snapshot['flightNumberOut'] ?? null,
      arrivalDateIn: snapshot['departureDateOut'] ?? null,
      arrivalHourIn: snapshot['departureHourOut'] ?? null,
      airportIn: snapshot['airportOut'] ?? null,
      airlineOut: snapshot['airlineIn'] ?? null,
      _flightNumberOut: snapshot['_flightNumberIn'] ?? null,
      flightNumberOut: snapshot['flightNumberIn'] ?? null,
      departureDateOut: snapshot['arrivalDateIn'] ?? null,
      departureHourOut: snapshot['arrivalHourIn'] ?? null,
      airportOut: snapshot['airportIn'] ?? null,
    });

    // Visual flags for the autocomplete labels
    const tmpAirlineIn = this.selectedAirlineInName;
    const tmpAirlineOut = this.selectedAirlineOutName;
    this.selectedAirlineInName = tmpAirlineOut;
    this.selectedAirlineOutName = tmpAirlineIn;

    const tmpAirportIn = this.selectedAirportIn;
    const tmpAirportOut = this.selectedAirportOut;
    this.selectedAirportIn = tmpAirportOut;
    this.selectedAirportOut = tmpAirportIn;
  }

    /**
 * Factory method que crea y retorna un nuevo objeto de vuelo con valores por defecto
 *
 * Este método genera un objeto de vuelo vacío con todas las propiedades inicializadas en null,
 * listo para ser completado con datos específicos. Sirve como template para nuevos vuelos.
 *
 * @returns {any} - Objeto de vuelo con todas las propiedades establecidas en null
 *
 * @structure
 * Propiedades del vuelo:
 * - Información de agente: agent_id
 * - Aerolíneas: airlineIn, airlineOut, airlineIataCodeIn, airlineIataCodeOut
 * - Aeropuertos: airportIn, airportOut, airportIataCodeIn, airportIataCodeOut, id_airport
 * - Fechas y horas: departureIn, departureOut, arrivalIn, arrivalOut
 * - Números de vuelo: flyNumberIn, flyNumberOut
 * - Información de itinerario: itinerary, iata_code
 * - Metadatos: id, created_at, updated_at, deleted_at
 *
 * @purpose
 * - Proporcionar un template consistente para nuevos vuelos
 * - Asegurar que todas las propiedades necesarias estén presentes
 * - Prevenir errores de propiedades undefined
 *
 * @example
 * // Crear nuevo vuelo:
 * const flight = this.newFly();
 * flight.airlineIn = "American Airlines";
 * flight.flyNumberIn = "AA123";
 *
 * @note
 * - Todas las propiedades se inicializan en null
 * - No incluye lógica de validación o business rules
 */
    newFly(opts?: { firstWay?: 1 | 2; flightDirection?: 'DEPARTURE' | 'ARRIVAL' }): any {
      return {
        agent_id: null,
        airlineIataCodeIn: null,
        airlineIataCodeOut: null,
        airlineIn: null,
        airlineOut: null,
        airportIataCodeIn: null,
        airportIataCodeOut: null,
        airportIn: null,
        airportOut: null,
        arrivalIn: null,
        arrivalOut: null,
        created_at: null,
        deleted_at: null,
        departureIn: null,
        departureOut: null,
        flyNumberIn: null,
        flyNumberOut: null,
        iata_code: null,
        id: null,
        id_airport: null,
        itinerary: null,
        updated_at: null,
        // Per-internal-flight metadata. Defaults to ARRIVAL if no opts given.
        firstWay: opts?.firstWay ?? 1,
        flight_direction: opts?.flightDirection ?? 'DEPARTURE',
      }
    }

/**
 * Elimina el vuelo interno (penúltimo) del array de vuelos del itinerario actual
 *
 * Este método remueve el vuelo en la penúltima posición del array de vuelos,
 * manteniendo intactos los vuelos inicial y final del itinerario.
 *
 * @returns {void}
 *
 * @logic
 * - Verifica que existan al menos 2 vuelos en el array
 * - Calcula la posición del penúltimo elemento (length - 2)
 * - Elimina 1 elemento en esa posición usando splice()
 *
 * @conditions
 * - Solo ejecuta si flights.length >= 2
 * - No hace nada si hay menos de 2 vuelos
 *
 * @position
 * - Elimina el elemento en índice: flights.length - 2
 * - Ejemplo: [A, B, C, D] → elimina C → resultado: [A, B, D]
 *
 * @modification
 * - Modifica directamente _actualItinerary.flights
 * - Usa Array.splice() para eliminación in-place
 *
 * @example
 * // Antes: flights = [A, B, C, D]
 * this.deleteFlyInternal();
 * // Después: flights = [A, B, D]
 *
 * @example
 * // Array con 2 elementos: [A, B]
 * this.deleteFlyInternal();
 * // Después: [A] (elimina el penúltimo, que es el primero en este caso)
 */
    deleteFlyInternal(data: any): void {

      if(data.flyExists) {
        this._removeFlight(data.id, false);
      }

      // The new flight being deleted is the last one in the array, regardless
      // of whether it was a persisted flight or a fresh stub. The previous
      // implementation used `length - 2`, which removed the second-to-last
      // element — that wiped out the previously-saved card when the user
      // added and then removed a stub.
      const deleteIndex = this.flightsInternal.length - 1;

      // Eliminar 1 elemento en la última posición
      this.flightsInternal.splice(deleteIndex, 1);

    }

    /**
     * Backend convention: a flight is "general" when `iataCityArrivalOut` and
     * `cityArrivalOut` are both empty/null/undefined. Anything else (including
     * flights with one of those fields set) is an internal flight. This lets
     * the user create internal flights without a general one — the backend
     * simply returns the internal flights, and we don't promote them.
     */
    getFlyItineraries(onComplete?: () => void): void {

    this._itineraryService.getFlightsItinerary(this. _actualItinerary?.id).subscribe({
      next: (res: any) => {
        if(res && res.data && res.data.length > 0) {
          this.flightsInternal = res.data.filter((flight: any) => !this._isGeneralFlight(flight));
        }
        if (onComplete) onComplete();
      }
    });
  }

  /**
   * A flight is "general" iff BOTH `iataCityArrivalOut` AND `cityArrivalOut`
   * are empty ('', null, or undefined). See backend `store()` validation —
   * those fields are populated only when the form-internal form submits them.
   */
  private _isGeneralFlight(flight: any): boolean {
    const iata = flight?.iataCityArrivalOut;
    const city = flight?.cityArrivalOut;
    return (iata === '' || iata === null || iata === undefined)
        && (city === '' || city === null || city === undefined);
  }

  /**
   * Reorders the flights array so the general flight (one without
   * iataCityArrivalOut / cityArrivalOut) is at index 0. If there is no
   * general flight, returns an array with a single empty placeholder so the
   * parent renders an empty general-flight form (Option B), while the actual
   * internals go to `flightsInternal` via `getFlyItineraries`.
   *
   * If there are multiple general flights (shouldn't happen but be safe),
   * keeps the first one at the head and drops the rest.
   */
  private _reorderFlightsGeneralFirst(flights: any[]): any[] {
    if (!flights || flights.length === 0) return flights;

    const generalIndex = flights.findIndex(f => this._isGeneralFlight(f));

    // No general flight — return empty placeholder so the parent shows an
    // empty general form, while `getFlyItineraries` puts internals elsewhere.
    if (generalIndex < 0) return [];

    // Exactly one flight and it's general — leave as-is.
    if (flights.length === 1) return flights;

    // General exists at index 0 — already correct.
    if (generalIndex === 0) return flights;

    // General exists elsewhere — move to front.
    const result = [...flights];
    const [general] = result.splice(generalIndex, 1);
    result.unshift(general);
    return result;
  }

  submitFlyInternals(): void {
    this.getFlyItineraries(() => this.cdr.detectChanges());
  }

  flightsInternalIds(): boolean {
    return this.flightsInternal.every(c => c.id !== null);
  }

getActualFlyInternal(flights: any[], value: string): any {
  if (!flights || flights.length < 1) {
    return null;
  }

  // Descartar primer y último elemento
  const middleFlights = flights;
  const currentDate = new Date();

  // 1. Buscar vuelo actual (en curso)
  const currentFlight = middleFlights.find(flight => {
    try {
      if (!flight?.departureOut || !flight?.arrivalOut) return false;

      const departure = new Date(flight.departureOut);
      const arrival = new Date(flight.arrivalOut);

      return currentDate >= departure && currentDate <= arrival;
    } catch (error) {
      console.error('Error procesando vuelo:', flight, error);
      return false;
    }
  });

  if (currentFlight && currentFlight[value]) {
    return currentFlight[value];
  }

  // 2. Si no hay vuelo actual, buscar próximo vuelo
  const nextFlight = middleFlights
    .filter(flight => flight?.departureOut)
    .sort((a, b) => new Date(a.departureOut).getTime() - new Date(b.departureOut).getTime())
    .find(flight => new Date(flight.departureOut) > currentDate);

  if (nextFlight && nextFlight[value]) {
    return nextFlight[value];
  }

  // Workaround: backend stores internal-shaped records in flights[] with iataCityArrivalOut/cityArrivalOut populated.
  const fallbackInternal = middleFlights.find(flight =>
    flight?.iataCityArrivalOut && flight?.cityArrivalOut
  );

  return fallbackInternal ? fallbackInternal[value] : null;
}



getDataTooltip(fly: any, index: number, value: string): string {
  const position = this.getPosition(index);
  return this.getDataFlyValue(fly, value, position);
}

private getPosition(index: number): 'first' | 'middle' | 'last' {
  const lastIndex = this.getFlyArr(this._actualItinerary?.flights).length - 1;

  if (index === 0) return 'first';
  if (index === lastIndex) return 'last';
  return 'middle';
}

private getDataFlyValue(fly: any, value: string, position: 'first' | 'middle' | 'last'): string {
  const valueMap = {
    iata: {
      first: () => fly.airportIataCodeIn,
      middle: () => fly.iataCityArrivalOut,
      last: () => fly.airportIataCodeOut
    },
    date: {
      first: () => fly.arrivalIn,
      middle: () => fly.arrivalOut,
      last: () => fly.departureOut
    }
  };

  return valueMap[value]?.[position]?.() || '';
}


getFlyArr(flights: any[]): any[] {

  if (!flights || flights.length === 0) return [];

  // Verificar si los flights han cambiado
  const hasChanged = this.hasFlightsChanged(flights);

  if (!hasChanged && this._cachedResult.length > 0) {
    return this._cachedResult;
  }

  // Calcular nuevo resultado: todos los vuelos originales + primer vuelo al final
  const result = [...flights]; // Copiar todos los vuelos originales

  // Agregar el PRIMER vuelo otra vez como "último" elemento
  if (flights[0]) {
    result.push(flights[0]);
  }

  // Actualizar cache
  this._lastFlights = [...flights];
  this._cachedResult = result;

  return result;
}

private hasFlightsChanged(newFlights: any[]): boolean {
  if (this._lastFlights.length !== newFlights.length) return true;

  for (let i = 0; i < newFlights.length; i++) {
    if (this._lastFlights[i]?.id !== newFlights[i]?.id) {
      return true;
    }
  }

  return false;
}

  onChildAccordionStateChange(isOpen: boolean) {
    this.isChildAccordionOpen = isOpen;
  }

  toggleTimePicker(pickerId: 'arrivalHourIn' | 'departureHourOut', event: Event): void {
    event.stopPropagation();
    this.activeTimePicker = this.activeTimePicker === pickerId ? null : pickerId;
  }

  /**
   * Format-as-you-type handler. Does NOT write to the form control here.
   * Just cleans the typed string and visually inserts a colon after 2 digits.
   * Called on every (input) event.
   */
  _onManualTimeInput(event: Event, controlName: 'arrivalHourIn' | 'departureHourOut'): void {
    const input = event.target as HTMLInputElement;
    const raw = input.value;

    // Strip everything except digits
    const digits = raw.replace(/\D/g, '').slice(0, 4);

    // Insert colon after 2 digits
    let formatted = digits;
    if (digits.length >= 3) {
      formatted = `${digits.slice(0, 2)}:${digits.slice(2)}`;
    } else if (digits.length === 2 && raw.includes(':')) {
      // User typed "14:" — keep the colon
      formatted = `${digits}:`;
    }

    // Only update the DOM value if it changed (prevents cursor jumping)
    if (input.value !== formatted) {
      const cursorPos = input.selectionStart || 0;
      input.value = formatted;
      // Restore cursor position (move it by the diff)
      const newPos = Math.min(cursorPos + (formatted.length - raw.length), formatted.length);
      input.setSelectionRange(newPos, newPos);
    }
  }

  /**
   * Blur handler. Validates and writes the final value to the form control.
   */
  _onTimeInputBlur(controlName: 'arrivalHourIn' | 'departureHourOut', event: FocusEvent): void {
    const input = event.target as HTMLInputElement;
    const dateField = controlName === 'arrivalHourIn' ? 'arrivalDateIn' : 'departureDateOut';
    const dateValue = this._formFlights.get(dateField)?.value;
    const fc = this._formFlights.get(controlName);

    // Normalize: digits only, then re-insert colon
    const digits = input.value.replace(/\D/g, '');
    if (digits.length === 0) {
      // Empty — clear if no date, otherwise use currentTime
      fc?.setValue(dateValue ? this.currentTime : null);
      input.value = dateValue ? this.currentTime : '';
      return;
    }

    // Pad and validate
    const padded = digits.padEnd(4, '0').slice(0, 4);
    const hours = parseInt(padded.slice(0, 2), 10);
    const minutes = parseInt(padded.slice(2, 4), 10);

    if (hours < 0 || hours > 23 || minutes < 0 || minutes > 59) {
      // Invalid — revert
      const prev = this._previousTimeValues[controlName];
      const fallback = prev || (dateValue ? this.currentTime : null);
      fc?.setValue(fallback);
      input.value = fallback || '';
      return;
    }

    const formatted = `${padded.slice(0, 2)}:${padded.slice(2, 4)}`;
    fc?.setValue(formatted);
    input.value = formatted;
    this._previousTimeValues[controlName] = formatted;
  }

  closeTimePicker(): void {
    this.activeTimePicker = null;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (this.activeTimePicker) {
      const target = event.target as HTMLElement;
      // Check if click was inside any wheel-picker-wrapper
      const pickerWrapper = target.closest('.wheel-picker-wrapper');
      if (!pickerWrapper) {
        this.activeTimePicker = null;
      }
    }
  }

}
